import * as React from "react";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import AutosizeInput from "react-input-autosize";
import moment from "moment";
import {
  Container, Form, Button, Dropdown,
  Spinner,
  OverlayTrigger, Tooltip,
  Modal,
  ButtonGroup,
} from "react-bootstrap";
import { FaPencilAlt } from 'react-icons/fa';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import paginationFactory from 'react-bootstrap-table2-paginator';
import PDFViewer from './pdf-viewer';
import { SingleSearchDropdownListBootrap } from "../Common/Components/SingleSearchDropdownListBootrap";
import TrackerSlideout from './Job/TrackerSlideout';
import { TransactionService } from '../Common/Services/TransactionService';
import { Utils } from "../Common/Utilis";
import { ConfirmationModal } from "../Common/Components/ConfirmationModal";
import ProductSlideout from "./Masters/ProductSlideout";
import Customerorderslideout from "./Customerorderslideout";
import { SingleDropdownListWithoutSearch } from "../Common/Components/SingleDropdownListWithoutSearch";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { CommentBox } from "../Common/Components/CommentBox";
import { PartTemplateService } from "../Common/Services/PartTemplateService";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { User } from "../Common/Services/User";
import { faArrowUp, faListSquares } from "@fortawesome/free-solid-svg-icons";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { CustomerService } from '../Common/Services/CustomerService';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { JobServices } from "../Common/Services/JobServices";
import  Vendororderslideout  from './Vendororderslideout';
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import { FaArrowUpFromBracket, FaCircleMinus, FaCirclePlus, FaEllipsis } from "react-icons/fa6";
import ScrollContainer from "react-indiana-drag-scroll";
import { WorkstationService } from '../Common/Services/WorkstationService';
import {
  faPlus,
  faMinus,faStopwatch 
} from "@fortawesome/free-solid-svg-icons";
import { MdDesignServices } from "react-icons/md";
import { FaLaptopHouse } from 'react-icons/fa';
import { confirmAlert } from "react-confirm-alert";
import { JobSearch } from '../Common/Components/JobSearch';
import Dropzone from "react-dropzone";
import { copyFile } from 'fs';
let storage = JSON.parse(localStorage.getItem("storage")!);

const { SearchBar } = Search;
let docViewerFiles: any = [];

class JobCreations extends React.Component<any, any> {
  private parentScroll: any;
  private scrollvdRef: any;
  private ChildComment: any;
  private child: any;
  private input: any;
  private scrollheight: any;
  private footerchk: any;
  private fileInputRef: any;
  private jobRouterRef : any;
  constructor(props: any) {
    super(props);
    this.parentScroll = React.createRef();
    this.fileInputRef = React.createRef();
    this.jobRouterRef = React.createRef();
    this.scrollvdRef = React.createRef();
    this.GetItemlist = this.GetItemlist.bind(this);
    this.getassigntodata = this.getassigntodata.bind(this);
    this.getjobdata = this.getjobdata.bind(this);
    this.getRefreshjobdata = this.getRefreshjobdata.bind(this);
    this.updateJobDetailsData = this.updateJobDetailsData.bind(this);
    this.scrollheight = React.createRef();
    this.GetUploadFileList = this.GetUploadFileList.bind(this);
    this.OpenViewer = this.OpenViewer.bind(this);
    //this.GetTemplateData =this.GetTemplateData.bind(this);
    this.ChildComment = React.createRef();
   

    this.state = {
      //tname: "",
      isAssignment : false,
      isQty : false,
      unsave : false,
      TypeUserlist:[],
      customerorderid:0,
      processLoad:false,
      IsDeleted:true,
      fileSelect:
        "data:application/pdf;base64,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",
      defaultView: "doc-view", 
      bulkSelect: false,
      isprevious: false,
      files: [],
      files1: [],
      savedfiles: [],
      newSelectfiles: [],
      totalCount: 0,
      isOpenViewer: false,
      currentZoom: 0.7,
      fileSize: 5242880,
      moreActionFileUpload1: [
        { name: "Delete", eventKey: "delete" },
        { name: "Download", eventKey: "download" },
        { name: "View", eventKey: "view" },
      ],
      editingIndex: null,
      currentNote: '',
      showPopup: false,
      isRecreate:false,
      ischanged: 0,
      isdataloaded:0,
      isLastJob: false,
      runningInTracker: false,
      processVendorPOCreated: false,
      materialVendorPOCreated: false,
      trackerProcessIds: [],
      trackerStatus: '',
      reworkCount: 0,
      ispopupshow: false,
      isshowsavetemplate: false,
      showProcessPopup:false,
      saveTemplate: false,
      jobTrackerId: 0,
      templatename: '',
      vendororderid: 0,
      vendorPoNo:'',
      Received:'',
      vendorordertype: 'Material',
      jobprocessid: 1,
      jobassignedid: 0,
      assignedto: "",
      jobprocess: "",
      orderid: this.props.orderid,
      //CustomerPoNumber: this.props.CustomerPoNumber,
      id: this.props.id,
      productid: this.props.productid,
      partname: this.props.partname,
      partNo: this.props.partNo,
      qtyOrdered: this.props.qtyOrdered,
      itemNo: this.props.itemNo,
      poNumber: this.props.poNumber,
      dueDate: this.props.dueDate,
      jobDesc: this.props.jobDesc,
      selectedCustomer: this.props.selectedCustomer,
      orderdate: this.props.orderdate,
      jobid:     this.props.jobid ==undefined?0: this.props.jobid,
      jobNo:"",
      manualTracking:true,
      templatetype: [],
      processdataList: [],
      assigneddatatoList: [],
      assignedtojob: [],
      itemListdatam: [],
      inventorydata: [],
      defaultitemname: [],
      jobMaster: [],
      itemdetailsdata: [
        {
          defaultitemname: [],
          itemNo: "1",
          id: 0,
          itemname: "MS-" + this.props.partNo,
          glcode: "",
          description: "",
          materialDesc:"",
          itemid: 0,
          stockqty: 0,
          qty: 0,
          orderqty: 0,
          unitPrice: Utils.currencyFormat(0),
          unit: "EA",
        },

      ],
      itemdetailsdatanew: [
        {
          defaultitemname: [],
          itemNo: "1",
          id: 0,
          glcode: "",
          itemname: "",
          description: "",
          itemid: 0,
          stockqty: 0,
          qty: 0,
          orderqty: 0,
          unitPrice: Utils.currencyFormat(0),
          unit: "EA",
        },

      ],
      itemColumns: this.itemColumns,
      columns: this.columns,
      pcolumns: this.pcolumns,
      partcolumns: this.partcolumns,
      customercolumns:this.customercolumns,
      jobcolumns:this.jobcolumns,
      // templateColumns: this.templateColumns,
      searcResult: [],
      templatedefault: "Custom",
      templatelistitem: [],
      customerlistitem: [],
      customerTemplates: [],
      orderData: [
        {
          defaultPartname: [],
          id: this.props.id,
          orderID: this.props.orderid,
          itemNo: this.props.itemNo,
          partname: this.props.partname,
          partNo: this.props.partNo,
          dueDate: this.props.dueDate,
          jobDesc: this.props.jobDesc,
          qtyOrdered: this.props.qtyOrdered,
          tenantid: 0,
          productid: this.props.productid,
        },

      ],
      formData: {
        templateid: 0,
        tname: "",
        templatename: '',
        jobdetails: [],
        itemdata: [],
        jobassignedId: 0,
        processid: 0,
        orderid: this.props.id,
        jobNo: "JO#"+this.props.poNumber + "-" + this.props.itemNo + this.props.rNo,
        partid: this.props.productid,
        jobid: this.props.jobid,
        DrawingNo:"",
        DrawingRevision:"",

      },
      jobdetailsdata: [
        {

          processList:this.props.processlist==undefined? [] : this.props.processlist,
          processid: 0,
          qty:0,assignedName:"",
          processName: "",


         srno: 1, type: 'Work', estimatehour: '',

          id: 0,
          jobid: 0,
          assignedid:0,
workstationid :0,  
    

          tdescription: "",

          tenantid: 0

        }

      ],
      processData:[],
      ppartData:[],
      selectedTemplateId:0,
      selectedTemplateName:'',
      selectedJobNo:'',
      templateType:'Template',

      newRow: [
        {
          processList:this.props.processlist==undefined? [] : this.props.processlist,
          // processid: this.props.processlist.length > 0 ? this.props.processlist[0].processid : 0,
          // processName: this.props.processlist.length > 0 ? this.props.processlist[0].name : "",
          processid: this.props.processlist?.[0]?.processid || 0,
          processName: this.props.processlist?.[0]?.name || "",
           qty:0,assignedName:"",
     assignedid:0,
         srno: 1, type: 'Work', estimatehour: '',

          id: 0,
          jobid: 0,


          tdescription: "",

          tenantid: 0

        }

      ],
    };
     let requestlist = { ...this.state.requestlist };
        WorkstationService.GetWorkstations(requestlist)
        .then(async (result: any[] | null) => {
            
          if (result != null) {
    
           // let isDevider: any = { bName: "", id: 0, name: "Devider", status: "isDevider" };
            this.state.TypeUserlist.push({id:0,name:'Devider', status: "isDevider"});
            result.forEach(element => {
              let item: any = {};
              item.id = 'w:'+ element.id;
              item.name = element.workstationName;
              item.status='Active';
              item.isStatusbadge=true;
              item.orderno=1;
              item.isWorkshop=1;
              this.state.TypeUserlist.push(item);
            });
          }
          resolve();
        })
        .catch((err: any) => {
          toast.error(`Server Error, ${err}`);
          reject();
        });

           User.getAllUsers()
        .then(async (result: any | null) => {
    
          if (result !== null) {
              this.state.TypeUserlist.push({id:'u:0',name:'Select'});
            result.forEach(element => {
              let item: any = {};
              item.id = 'u:'+ element.user_UniqueID;
              item.name =  element.userName;
              item.status='Active';
              item.isStatusbadge=false;
              item.orderno=0;
              item.isWorkshop=0;
              this.state.TypeUserlist.push(item);
            });
          }
          resolve();
          // console.log(this.state.processList);
        })
        .catch((error) => {
          this.setState({ isSpinner: false });
          reject();
        });
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.updatedCommentItem = this.updatedCommentItem.bind(this);
  }
 
  private iconFormatter = (column, colIndex) => {
    const renderTooltip = (props) => (
      <Tooltip id="button-tooltip" {...props}>
        Select Process
      </Tooltip>
    );
    return (
        <div>Process 
          <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
          <button  onClick={(e)=>{ this.setState({ showProcessPopup: true });}} className='btnheight' disabled={this.state.runningInTracker?true:false}  >
            
          {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-clipboard-check-fill" viewBox="0 0 16 16">
  <path d="M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/>
  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
</svg> */}
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-journal-check" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
  <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"/>
  <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"/>
</svg>
            </button>
            </OverlayTrigger>
            </div> 
    );
};

 

  private itemColumns = [
    //{
    //   dataField: "itemNo",
    //   text: "#",
    // },

    {
      dataField: "itemname",
      text: "Material ID",
      headerClasses: "coa",

      headerStyle: { width: "500px" },
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),

      formatter: (cell: any, row: any, rowIndex: any) => {
        let btnId = "itemname" + rowIndex + "btn";
        let id = "itemname" + rowIndex + "ddl";
        const defaultitemname = row.selectitem;
        let disable = this.state.vendorPoNo!=null && this.state.vendorPoNo!="" ? true : false;
        return (
          // <div className="disabled-area my-class" onClick={(e)=>this.onclickevent(e)}>
          <div
          //  onClick={() => $('#tbltemplate td.reset-expansion-style').css('overflow', 'inherit')}
          >
            <div className="more-action single-select-image dropdown coa-select">

              {<Typeahead
disabled={disable}
                id={"itemname" + rowIndex + "ddl"}
                inputProps={{
                  className: "rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex + "ddl",
                  title: defaultitemname,
                  onClick: () => this.hoverOutEllipsis()
                }}
                options={
                  //             this.state.inventorydata.filter(
                  //   (x) => x.itemname !== ""
                  // )
                  this.state.inventorydata.filter((ele, ind) => ind === this.state.inventorydata.findIndex(elem => elem.itemname === ele.itemname && ele.itemname !== ""))

                }

                placeholder={"Enter item Name"}

                // labelKey="label"

                renderMenu={(results: any, menuProps) => (
                  <Menu style={{ zIndex: "-1" }}  {...menuProps}>
                    {results.map((result: any, index: any) => (
                      <>
                        {this.state.inventorydata.length > 0}
                        {result.label !== "" && (
                          <MenuItem
                            option={result}
                            position={index}
                            onWheel={() => this.hoverOutEllipsis()}
                          >
                            <EllipsisWithTooltip placement="bottom">
                              {result.label}

                            </EllipsisWithTooltip>
                          </MenuItem>
                        )}

                        {result.itemname === "" && (
                          <MenuItem option={result} position={index}></MenuItem>
                        )}
                      </>
                    ))}
                  </Menu>
                )}

                onChange={this.handleSelectedItemInv.bind(
                  this,
                  1 + "_" + rowIndex + "_" + defaultitemname
                )}
                selected={row.defaultitemname}
                allowNew
                onBlur={this.handleOutsideClick.bind(this, rowIndex)}
                onKeyDown={this.onTAB.bind(this, "itemname-" + rowIndex.toString() + "ddl", rowIndex)}

              />}

              <button id={btnId} style={{ display: "none", width: "100%" }}
                onClick={() => { this.handleCOAFocus(btnId, id, "rbt-input-main form-control rbt-input itemname" + rowIndex + "ddl", rowIndex); }}
                onFocus={() => { this.handleCOAFocus(btnId, id, "rbt-input-main form-control rbt-input itemname" + rowIndex + "ddl", rowIndex); }} >
                {row.partname === "" && (
                  <EllipsisWithTooltip placement="bottom">{"Enter item name"}</EllipsisWithTooltip>
                )}
                {row.partname !== "" && (
                  <EllipsisWithTooltip placement="bottom">{defaultitemname}</EllipsisWithTooltip>
                )}
              </button>
            </div>
          </div>
        );
      },
    },
  {
      dataField: "materialDesc",
      text: "Material Description",
      headerStyle: { width: "25%" },
      hidden: false,
      editable: false,
      classes:"text-truncate",
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtmaterialDesc" + rowIndex + "txt";
        return (
        
  
            <div style={{ position: 'relative' }}>
            <div className="btn-group w-100">
            
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Description"
              // value={row.partname}
              value={row.materialDesc.split('\n')[0]}
              onChange={(e) => this.updateState(e, rowIndex, "materialDesc", id)}
              autoComplete="off"
              title={row.materialDesc}
              maxLength={500}
              className="form-control form-control-sm text-truncate"
              style={{ paddingRight: '30px',width:'100%' }} 
            />
          
             <FaPencilAlt 
            
                onClick={() => this.handleEditClick1(rowIndex, row.materialDesc)} 
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                }} 
              />
     
          </div>
     
          </div>
      
        );
      },

    },
    {
      dataField: "glcode",
      text: "MS Code",
      headerStyle: { width: "150px" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtglcode" + rowIndex + "txt";
        let disable = this.state.vendorPoNo!=null && this.state.vendorPoNo!="" ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter MS Code"
              value={row.glcode}
              onChange={(e) => this.updateState(e, rowIndex, "glcode", id)}
              autoComplete="off"
              onKeyDown={(e: any) => this.onTAB("glcode", rowIndex, e)}
              disabled={disable}
              title=""
            />
          </div>
        );
      },
    },



    {
      dataField: "unit",
      text: "Unit",
      headerStyle: { width: "70px" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtunit" + rowIndex + "txt";
        let disable = this.state.vendorPoNo!=null && this.state.vendorPoNo!="" ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              //placeholder="Enter Qty"
              value={row.unit}
              onChange={(e) => this.updateState(e, rowIndex, "unit", id)}
              autoComplete="off"

              maxLength={20}
              disabled={disable}
              title=""
            />
          </div>
        );
      },
    },


    {
      dataField: "stockqty",
      text: "Stock Qty",
      headerStyle: { width: "70px" },
      hidden: true,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtstockqty" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            {row.stockqty}
          </div>
        );
      },
    },

    {
      dataField: "qty",
      text: "Req Qty",
      headerStyle: { width: "70px" },
      hidden: true,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtreqqty" + rowIndex + "txt";
        let disable = this.state.vendorPoNo!=null && this.state.vendorPoNo!="" ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              // placeholder="Enter Qty"
              value={row.qty}
              onChange={(e) => this.updateState(e, rowIndex, "reqqty", id)}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={disable}
              title=""
            />
          </div>
        );
      },
    },


    {
      dataField: "orderqty",
      text: "Order Qty",
      headerStyle: { width: "70px" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtqty" + rowIndex + "txt";
        let disable = this.state.vendorPoNo!=null && this.state.vendorPoNo!="" ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              //   placeholder="Enter Qty"
              value={row.orderqty}
              onChange={(e) => this.updateState(e, rowIndex, "orderqty", id)}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={disable}
              title=""
            />
          </div>
        );
      },
    },
    {
      dataField: "unitPrice",
      text: "Unit Price",
      headerStyle: { width: "70px" },
      headerClasses: 'amount',
      classes: 'amount',
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtunitPrice" + rowIndex + "txt";
        let disable = this.state.vendorPoNo!=null && this.state.vendorPoNo!="" ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              //  placeholder="Enter unit Price"
              value={row.unitPrice}
              onChange={(e) => this.updateState(e, rowIndex, "unitPrice", id)}
              onBlur={(e: any) => this.amountBlur(e, rowIndex, "unitPrice")}
              onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "unitPrice")}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={disable}
              title=""
            />
          </div>
        );
      },
    },
    {
      dataField: 'Attachment',
      text: '',
      //headerFormatter: this.iconFormatter,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let itemDetailConfirmModalContent = [
          {
            title: "Delete Row",
            desc: "Are you sure you want to delete?",
            cancleAction: "Cancel",
            ActionTrue: "Delete",
          },
        ];
        if (this.state.itemdetailsdata.length === 1  || true) {
          return (
            <div></div>
          );
        }
        else {
          return (
            <Dropdown className="more-action confirmation-modal"  tabIndex={this.state.tabDisable}>
              <Dropdown.Toggle className="btn-outline-primary btn btn-primary more fa-trash" id="dropdown-more-delete" tabIndex={this.state.tabDisable}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 5.83329C4.53917 5.83329 4.16667 5.83329 4.16667 5.83329V16.6666C4.16667 17.5866 4.91333 18.3333 5.83333 18.3333H14.1667C15.0867 18.3333 15.8333 17.5866 15.8333 16.6666V5.83329C15.8333 5.83329 15.4608 5.83329 15 5.83329H5ZM8.33333 15.8333H6.66667V8.33329H8.33333V15.8333ZM13.3333 15.8333H11.6667V8.33329H13.3333V15.8333ZM13.8483 3.33329L12.5 1.66663H7.5L6.15167 3.33329H2.5V4.99996H6.66667H13.3333H17.5V3.33329H13.8483Z" />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ConfirmationModal
                  confirmModalContent={itemDetailConfirmModalContent}
                  ishandleDeletePosition={this.handleItemDetailDeleteRow.bind(
                    this,
                    row
                  )}
                />
              </Dropdown.Menu>
            </Dropdown>
          );
        }
      },
    },

  ];

  private columns = [
    {
      dataField: "id",
      text: "id",
      hidden: true,
    },
   
    {
      dataField: "name",
      text: "Template Name",
      searchable:true,
      
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          
         <div>
            {row.name}
            </div>
        );
      },
    },
  ];

  private customercolumns = [
    {
      dataField: "id",
      text: "id",
      hidden: true,
    },
    
    {
      dataField: "template_name",
      text: "Template Name",
      // searchable:true,
      
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          
         <div>
            {row.template_name}
            </div>
        );
      },
    },
    {
      dataField: "customer_name",
      text: "customer Name",
      searchable:true,
      hidden: true,
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          
         <div>
            {row.customer_name}
            </div>
        );
      },
    },
  ];

  
  private pcolumns = [
   
   
    {
      dataField: "processName",
      text: "Steps",
      headerStyle: { width: "100px" },
      
    },
    {
      dataField: "jDescription",
      text: "Description",
      headerStyle: { width: "500px" },
    },
  ];

  private partcolumns = [
    {
      dataField: "jobid",
      text: "id",
      hidden: true,
      headerStyle: { width: "100px" },
       
    },
   
    {
      dataField: "partno",
      text: "Part No",
      hidden: false,
      headerStyle: { width: "100px" },
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          
         <div>
            {row.partno}
            </div>
        );
      },
    },
    {
      dataField: "partName",
      text: "Part Description",
      headerStyle: { width: "33%" },
      classes:"text-truncate",
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
         
          <div className="d-flex align-items-center txt-bold">
             <div style={{width: '150px'}}>
            <EllipsisWithTooltip placement="bottom">
              {row.partName}
            </EllipsisWithTooltip>
          </div>
          </div>
        );
      },
    
    },
  ];

  private jobcolumns = [
    {
      dataField: "jobid",
      text: "id",
      hidden: true,
      headerStyle: { width: "100px" },
      
    },
    {
      dataField: "jobNo",
      text: "Job #",
      hidden: false,
      headerStyle: { width: "100px" },
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          
         <div>
            {row.jobNo}
            </div>
        );
      },
    },
   
    {
      dataField: "partno",
      text: "Part No",
      hidden: false,
      headerStyle: { width: "100px" },
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          
         <div>
            {row.partno}
            </div>
        );
      },
    },
    {
      dataField: "partName",
      text: "Part Description",
    
      headerStyle: { width: "33%" },
      classes:"text-truncate",
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
         
          <div className="d-flex align-items-center txt-bold">
             <div style={{width: '120px'}}>
            <EllipsisWithTooltip placement="bottom">
              {row.partName}
            </EllipsisWithTooltip>
          </div>
          </div>
        );
      },
    },
  ];

  handleTemplateOnSelect = (row, isSelect) => {  
    
    let templatelistitem = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.templatelistitem))
    );

    templatelistitem.forEach(element => {
        if(element.id == row.id)
        {
          element.selected = isSelect;
        }
        else         
          element.selected = false;
    });

  
    this.setState({ searcResult: templatelistitem,selectedTemplateId:row.id, selectedTemplateName: row.name,isSpinner:false,templateType:'Template' },()=>{
   

     this.getProcessDataforPopup(row.id);
    });

  };

  handlePartOnSelect = (row, isSelect) => {  
    let partData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.partData))
    );

    partData.forEach(element => {
        if(element.jobid == row.jobid)
        {
          element.selected = isSelect;
        }
        else         
          element.selected = false;
    });

    // let selectTemplateId = 0, selectTemplateName = '';
    // if(this.state.templatelistitem.length > 0 )
    // {
    //     selectTemplateId = this.state.templatelistitem[0].id;
    //     selectTemplateName = this.state.templatelistitem[0].name;
    // }

    this.setState({ partData: partData,selectedTemplateId:row.jobid, selectedTemplateName: row.partno,isPopupSpinner:true,templateType:'Part',selectedJobNo: row.partno + ' ' + row.partName},()=>{
   
     this.getProcessDatabyPartJobForPopup(row.jobid);

    });

  };

  handleCustomerOnSelect = (row, isSelect) => {  
    let customerData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.customerData))
    );

    customerData.forEach(element => {
        if(element.jobid == row.jobid)
        {
          element.selected = isSelect;
        }
        else         
          element.selected = false;
    });


    this.setState({ customerData: customerData,selectedTemplateId:row.jobid, selectedTemplateName: row.partno,isPopupSpinner:true,templateType:'Customer',selectedJobNo: row.partno + ' ' + row.partName},()=>{
   

    });

  };

 
   handleSelectedItemCustomer = (customerId: number) => {
    let customerTemplates = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.customerTemplatesOriginal))
    );

    const filteredCustomers = customerTemplates.filter((template) => 
      template.customerList.some((customer) => customer.customerid === customerId)
    );
    console.log("Filtered Customers: ", filteredCustomers);

    this.setState({customerTemplates: filteredCustomers});
  };
  
  
  handlejobOnSelect = (row, isSelect) => {  
    let partData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.partData))
    );

    partData.forEach(element => {
        if(element.jobid == row.jobid)
        {
          element.selected = isSelect;
        }
        else         
          element.selected = false;
    });

    // let selectTemplateId = 0, selectTemplateName = '';
    // if(this.state.templatelistitem.length > 0 )
    // {
    //     selectTemplateId = this.state.templatelistitem[0].id;
    //     selectTemplateName = this.state.templatelistitem[0].name;
    // }

    this.setState({ partData: partData,selectedTemplateId:row.jobid, selectedTemplateName: row.jobNo,isPopupSpinner:true,templateType:'Part',selectedJobNo: row.jobNo},()=>{
   
     this.getProcessDatabyPartJobForPopup(row.jobid);

    });

  };
  handleCOAFocus = (btnID, txtID, ddlID, rowIndex) => {
    
    let itemdetailsdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.itemdetailsdata))
    );


    this.setState({ itemdetailsdata: [] }, () => this.setState({ itemdetailsdata }, () => {
      
      $("input[class^='" + ddlID + "']").focus();
    }));
    // $("#tblSplit").find("button[id^='" + btnID + "']").css("display", 'none');
    // $("#tblSplit").find("div[id^='" + txtID + "']").css("display", 'block');

  };

  handleRowOrdering = (e: any, row: any, type: any) => {

    let jobdetailsdata = this.state.jobdetailsdata;
    
    let nextOrderNo = type == 'down' ? row.processOrder + 1 : row.processOrder - 1;
    let currentRow = jobdetailsdata.filter((x) => x.processOrder == row.processOrder);
    let nextRow = jobdetailsdata.filter((x) => x.processOrder == nextOrderNo);

    if (nextRow != null && nextRow.length > 0) {

      nextRow[0].processOrder = row.processOrder;
      currentRow[0].processOrder = nextOrderNo;


      jobdetailsdata = jobdetailsdata.sort((a, b) => a.processOrder - b.processOrder);

      this.setState({ jobdetailsdata: jobdetailsdata }, () => {
        this.setState({ jobdetailsdata: jobdetailsdata });
      });

      this.ReorderProcess();
    }

  };

  componentDidMount() {
    this.getjobdata();

   if (this.props.routerRef) {
    setTimeout(() => {
      if (this.jobRouterRef.current) {
        this.jobRouterRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }, 1000);

  }  }

  getCustomer = () => {
    let requestlist = {};
    CustomerService.GetCustomerlist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          
          let customerNameMap = result
            .filter((item) => item.status === "Active")
            .reduce((map, item) => {
              map[item.customer_id] = item.company_name;
              return map;
            }, {});

   let updatedTemplates = this.state.customerTemplates.map(template => {
            let customerNames = template.
            customerList
              .map(mapping => customerNameMap[mapping.customerid])
              .join(',');
            return {
              ...template,
              customer_name: customerNames,
            };
          });
  
          let selectOptions = result
          .filter((item) => item.status === "Active")
          .map((item) => ({
            id: item.customer_id,
            name: item.company_name,
          }));
         
 let customerTemplatesOriginal = updatedTemplates;

          this.setState({ customerTemplatesOriginal,customerTemplates: updatedTemplates,customerlistitem: selectOptions });
        }
      })
      .catch((error) => {
        console.error("Error fetching customer list:", error);
      });
  };
  

  // getCustomer = () => {
  //   let requestlist: any = {};
  //   CustomerService.GetCustomerlist(requestlist)
  //     .then(async (result: any | null) => {
  //       if (result !== null) {
  //         console.log("ress", result);
          // let selectOptions = result
          //   .filter((item) => item.status === "Active")
          //   .map((item) => ({
          //     id: item.customer_id,
          //     name: item.company_name,
          //   }));
          // this.setState({ customerlistitem: selectOptions });
  //       }
  //       resolve();
  //     })
  //     .catch((error) => {
  //       reject();
  //     });
  // };

  Getjoblist = (requestlist: any) => {

    let saveRequest: any = {};
    saveRequest.orderid = this.state.formData.orderid;
    saveRequest.partid = this.state.formData.partid;
    saveRequest.jobid = this.state.formData.jobid;
    let request: any = {};
    let itemdetailsdata: any = [];

    let jobdetailsdata = Object.assign([], JSON.parse(JSON.stringify(this.state.jobdetailsdata)));
    
    JobServices.GetJobData(saveRequest)
      .then(async (resultinv: any | null) => {
        debugger;
        if (resultinv !== null && resultinv.jobmaster.length > 0) {
          debugger;
          let jobNoList = resultinv.jobmaster.map(obj => {
            return {
              id: obj.jobid,
              name: obj.jobNo,
              reworkCount: obj.reworkCount
            };
          });
          
            let formData = { ...this.state.formData };
            formData.DrawingNo= this.state.formData.jobid != 0 ? resultinv.jobmaster[0].drawingNo : "";
            formData.DrawingRevision=resultinv.jobmaster[0].drawingRevision;
            formData.jobNo=resultinv.jobmaster[0].jobNo;
            if(this.state.jobid !== 0){formData.jobNo=this.state.isRecreate==true ?  resultinv.jobmaster[0].jobNo + "-RW" : resultinv.jobmaster[0].jobNo;}
            debugger;
            this.setState({
            formData:formData,
            customerorderid:resultinv.customerorderid,
            isLastJob: resultinv.isLastJob,
            runningInTracker: this.state.isRecreate==true ? false :  resultinv.runningInTracker,
            trackerStatus:this.state.isRecreate==true ? '' : resultinv.jobmaster[0].trackerStatus == null ? '' : resultinv.jobmaster[0].trackerStatus,
            reworkCount: resultinv.jobmaster[0].reworkCount,
            partname: resultinv.jobmaster[0].partName,
            // manualTracking: this.state.isRecreate==true ? true : resultinv.jobmaster[0].manualTracking == null ? false:resultinv.jobmaster[0].manualTracking,
            manualTracking: this.state.formData?.jobid == null || this.state.formData.jobid == 0 ? true
            : this.state.isRecreate === true ? true: resultinv.jobmaster[0].manualTracking == null ? false : resultinv.jobmaster[0].manualTracking,
            partNo: resultinv.jobmaster[0].partNo,
            qtyOrdered: resultinv.jobmaster[0].qtyOrdered,
            orderdate: resultinv.jobmaster[0].orderDate,
            dueDate: resultinv.jobmaster[0].dueDate,
            CustomerPoNumber:resultinv.jobmaster[0].customerPONumber ==""? this.props.CustomerPoNumber :  resultinv.jobmaster[0].customerPONumber,
            selectedCustomer: resultinv.jobmaster[0].customername,
            jobid: resultinv.jobmaster[0].jobid, jobTrackerId: resultinv.jobtrackerid,
            vendororderid: this.state.isRecreate==true ? 0 : resultinv.vendorOrderId, 
            vendorPoNo:this.state.isRecreate==true ? "" : resultinv.vendorPoNo, 
            Received:this.state.isRecreate==true ? false : resultinv.received, 
            assignedto: resultinv.jobmaster[0].assignedTo,
            jobassignedid: resultinv.jobmaster[0].jobassignedId,
            jobprocess: resultinv.jobmaster[0].process, 
            jobprocessid: resultinv.jobmaster==null ||  resultinv.jobmaster.length > 0? resultinv.defaultprocessId : resultinv.jobmaster[0].processid,
            processVendorPOCreated:this.state.isRecreate==true ? false : resultinv.jobmaster[0].processVendorPOCreated,
            trackerProcessIds: this.state.isRecreate==true ? null :resultinv.trackerProcessIds,
            materialVendorPOCreated: this.state.isRecreate==true ? null : resultinv.jobmaster[0].materialVendorPOCreated,
            isdataloaded: 1, jobMaster: jobNoList
          });
          this.GetUploadFileList( resultinv.jobmaster[0].jobid, 1);


          if(resultinv.material.length==0)
          {
            
            resultinv.material=  this.state.itemdetailsdata;

          }
       
          resultinv.material.forEach(element => {

            let defaultitemname: any = [];
            let objPartname: any = {};

            objPartname.itemname = element.itemname;
            objPartname.label = element.itemname;
            objPartname.id = element.itemid;



            objPartname.tenantid = 0;


            defaultitemname.push(objPartname);
            element.defaultPartname = defaultitemname;

            let matr: any = {};

            matr.id = element.id,
              matr.itemname = element.itemname,
              matr.glcode = element.glcode,
              matr.itemid = element.itemid,
              matr.stockqty = element.stockqty,
              matr.qty = element.reqqty,
              matr.orderqty = element.orderqty,
              matr.unitPrice = Utils.currencyFormat(element.unitprice),
              matr.unit = element.unit,
              matr.materialDesc = element.materialDesc || "",
              matr.defaultitemname = element.defaultPartname,
              itemdetailsdata.push(matr);
          });
       
          let jobdetailsdata: any = [];
          let newRow = this.state.newRow;
          let orderArray = resultinv.jobdetails;
          let isQty = false;
          let isAssignment = false;
          let isloaded=orderArray.length ;
          
          if (orderArray.length > 0) {
            orderArray.forEach((element, idx) => {
            const qtyValue = element.qty != null ? element.qty : 0;

              let el: any = {};
              el.id = element.id;
              el.processList = this.state.processdataList;
              el.srno = idx + 1;
              el.processName = element.processname;
              el.processid = element.processid;
              el.jDescription = element.jdescription;
              el.assignedid = element.assignedid != null ? element.assignedid : 0;
              el.workstationid = element.workstationid != null ? element.workstationid : 0;
              el.id = element.id;
              el.type = element.type;
              el.assignedName = element.assignedName;
              el.qty = qtyValue;
              el.processOrder = idx + 1; //element.processOrder;
              let tracker = resultinv.jobdetailstracker
                  ? resultinv.jobdetailstracker.find(t => t.id == element.id)
                  : null;

              el.trackQty = tracker && tracker.completedqty > 0 && !this.state.manualTracking ? tracker.completedqty : 0;  
              el.status =  tracker && tracker.status != ""  && tracker.status != null ? tracker.status : "inactive";
              el.status = this.state.manualTracking == false ? el.status : null;
              jobdetailsdata.push(el);

               if (qtyValue > 0) isQty = true;
               if (el.assignedid > 0 || el.workstationid > 0) isAssignment = true;
              //          let requestlist = { ...this.state.requestlist };
              //            this.GetTempateType(requestlist);
            });

            newRow.forEach(element => {
              element.processList = this.state.processdataList;
              // element.processName = filterRow[0].name;
              // element.processid = orderArray[idx].processid;

            });
          }
          else {
            if(isloaded==0)
            {
            var prid= this.state.templatelistitem.filter(x => x.name === "Custom");
            this.getTemplateData(prid[0].id);
            }
            else
            {
           
            this.getTemplateData(this.state.jobprocessid);
            }
          
          }

    
          this.setState({
            itemdetailsdata: itemdetailsdata,
            jobdetailsdata: jobdetailsdata, 
            isQty: this.state.manualTracking ? isQty : true,
            isAssignment:this.state.manualTracking ? isAssignment:true
          },
            () => {
              this.setState({ jobdetailsdata: [], }, () => {
                this.setState({
                  jobdetailsdata: jobdetailsdata,

                });

              });
             
            });

          let processid = resultinv.jobmaster[0].processid;





          this.setState({ itemdetailsdata: [], jobdetailsdata: [], }, () => {
            this.setState({ itemdetailsdata: itemdetailsdata, jobdetailsdata: jobdetailsdata });
            //this.getjobdata(processid);


          });


        };

        if(this.state.CustomerPoNumber==undefined)
        {

          this.setState({   CustomerPoNumber: this.props.CustomerPoNumber });
        };
        
        let assignedTo = this.state.assignedto;
        let jobprocess = this.state.jobprocess;
        let jobprocessid=this.state.jobprocessid;
        // if(this.state.assignedto === '')
        //    assignedTo ='Unassigned';
        if (this.state.jobprocess === '')
        {
          jobprocess = 'Custom';
          var prid= this.state.templatelistitem.filter(x => x.name === "Custom");
          jobprocessid=prid[0].id;
          //itemdetailsdata: this.state.itemdetailsdata;

          if(resultinv.material.length==0)
            {
              
              resultinv.material=  this.state.itemdetailsdata;
  
            }
         
            resultinv.material.forEach(element => {
  
              let defaultitemname: any = [];
              let objPartname: any = {};
  
              objPartname.itemname = element.itemname;
              objPartname.label = element.itemname;
              objPartname.id = element.itemid;
  
  
  
              objPartname.tenantid = 0;
  
  
              defaultitemname.push(objPartname);
              element.defaultPartname = defaultitemname;
  
              let matr: any = {};
  
              matr.id = element.id,
                matr.itemname = element.itemname,
                matr.glcode = element.glcode,
                matr.itemid = element.itemid,
                matr.stockqty = element.stockqty,
                matr.qty = element.reqqty,
                matr.orderqty = element.orderqty,
                matr.unitPrice = Utils.currencyFormat(element.unitprice),
                matr.unit = element.unit,
                matr.materialDesc = element.materialDesc || "",
                matr.defaultitemname = element.defaultPartname,
                itemdetailsdata.push(matr);
            });
        }

        this.setState({jobprocessid:jobprocessid, isdataloaded: 1, jobprocess: jobprocess, assignedto: assignedTo,
          itemdetailsdata: itemdetailsdata,
          
         });
        resolve();

      })


      .catch((error) => {

        reject();
      });
  };

  ReorderProcess = () => {

    let request = { ...this.state.requestlist };
    let jobdetailsdata = this.state.jobdetailsdata;
    jobdetailsdata.forEach((element, idx) => {
      //jobdetailsdata.forEach(element => {
      let item: any = {};
      item.srno = idx + 1;
      item.id = element.id;
      item.jobid = this.state.jobid;
      item.processid = element.processid;
      item.processname = element.processName;
      item.type = element.type;
      item.jdescription = element.tdescription;
      item.processOrder = element.processOrder;
      item.assignedid = element.assignedid == null ? this.state.jobassignedid : element.assignedid;
      item.tenantid = 0;
      this.state.formData.jobdetails.push(item);
    });


    // request = Object.assign([], JSON.parse(JSON.stringify(this.state.formData.jobdetails)));

    // JobServices.ReorderProcess(request)
    // .then(async (result: any | null) => {

    //   if (result !== null) {
    //   console.log('sss');
    //   }

    //   resolve();

    // })
    // .catch((error) => {
    //   reject();
    // });

  };

  GetJobDataByIdOnly = () => {

    let request: any = {};
    request.jobid = this.state.formData.jobid;

    // request: any = {};
    let itemdetailsdata: any = [];

    let jobdetailsdata = Object.assign([], JSON.parse(JSON.stringify(this.state.jobdetailsdata)));

    JobServices.GetJobDataByIdOnly(request)
      .then(async (resultinv: any | null) => {

        if (resultinv !== null && resultinv.jobmaster.length > 0) {
          /* let jobNoList = resultinv.jobmaster.map(obj => {
             return {
                 id: obj.jobid,
                 name: obj.jobNo,
                 reworkCount: obj.reworkCount
             };
         }); */
          this.setState({
            trackerStatus: resultinv.jobmaster[0].trackerStatus == null ? '' : resultinv.jobmaster[0].trackerStatus,
            reworkCount: resultinv.jobmaster[0].reworkCount,
            partname: resultinv.jobmaster[0].partName,
            partNo: resultinv.jobmaster[0].partNo,
            qtyOrdered: resultinv.jobmaster[0].qtyOrdered,
            manualTracking: resultinv.jobmaster[0].manualTracking == null ? false:resultinv.jobmaster[0].manualTracking,

            orderdate: resultinv.jobmaster[0].orderDate,
            dueDate:resultinv.jobmaster[0].dueDate,
            selectedCustomer: resultinv.jobmaster[0].customername,
            jobid: resultinv.jobmaster[0].jobid, jobTrackerId: resultinv.jobtrackerid,
            vendororderid: resultinv.vendorOrderId, assignedto: resultinv.jobmaster[0].assignedTo,
            jobassignedid: resultinv.jobmaster[0].jobassignedId,
            jobprocess: resultinv.jobmaster[0].process, jobprocessid: resultinv.jobmaster[0].processid,
            processVendorPOCreated: resultinv.jobmaster[0].processVendorPOCreated,
            trackerProcessIds: resultinv.trackerProcessIds,
            materialVendorPOCreated: resultinv.jobmaster[0].materialVendorPOCreated,
            isdataloaded: 1
          });

          resultinv.material.forEach(element => {

            let defaultitemname: any = [];
            let objPartname: any = {};

            objPartname.itemname = element.itemname;
            objPartname.label = element.itemname;
            objPartname.id = element.itemid;



            objPartname.tenantid = 0;


            defaultitemname.push(objPartname);
            element.defaultPartname = defaultitemname;

            let matr: any = {};

            matr.id = element.id,
              matr.itemname = element.itemname,
              matr.glcode = element.glcode,
              matr.itemid = element.itemid,
              matr.stockqty = element.stockqty,
              matr.qty = element.reqqty,
              matr.orderqty = element.orderqty,
              matr.unitPrice = element.unitprice,
              matr.unit = element.unit,
              matr.materialDesc = element.materialDesc || "",
              matr.defaultitemname = element.defaultPartname,
              itemdetailsdata.push(matr);
          });

          let jobdetailsdata: any = [];
          let newRow = this.state.newRow;
          let orderArray = resultinv.jobdetails;
          if (orderArray.length > 0) {
            orderArray.forEach((element, idx) => {
         
              let el: any = {};
              el.id = element.id;
              el.processList = this.state.processdataList;
              el.srno = idx + 1;
              el.processName = element.processname;
              el.processid = element.processid;
              el.tdescription = element.jdescription;
              el.jDescription = element.jdescription;
              el.id = element.id;
              el.type = element.type;
              el.qty = element.qty || 0;
              el.assignedid = element.assignedid != null ? element.assignedid : 0;
              el.workstationid = element.workstationid != null ? element.workstationid : 0;
              el.assignedName = element.assignedName;
                       
              jobdetailsdata.push(el);
              //          let requestlist = { ...this.state.requestlist };
              //            this.GetTempateType(requestlist);
            });
            newRow.forEach(element => {
              element.processList = this.state.processdataList;
              // element.processName = filterRow[0].name;
              // element.processid = orderArray[idx].processid;

            });
          }

          this.setState({
            itemdetailsdata: [],
            jobdetailsdata: [],
          },
            () => {this.setState({
                  jobdetailsdata: jobdetailsdata,
                 itemdetailsdata: itemdetailsdata,
                });
             
            });

          let processid = resultinv.jobmaster[0].processid;





          // this.setState({ itemdetailsdata: [], jobdetailsdata: [], }, () => {
          //   this.setState({ itemdetailsdata: itemdetailsdata, jobdetailsdata: jobdetailsdata });
          //   //this.getjobdata(processid);


          // });


        };
        let assignedTo = this.state.assignedto;
        let jobprocess = this.state.jobprocess;
        let jobprocessid=this.state.jobprocessid;
        if (this.state.assignedto === '')
          assignedTo = 'Unassigned';
        if (this.state.jobprocess === '')
        {
          jobprocess = 'Custom';
          var prid= this.state.templatelistitem.filter(x => x.name === "Custom");
          jobprocessid=prid[0].id;
        }
        this.setState({ jobprocessid:jobprocessid, isdataloaded: 1, jobprocess: jobprocess, assignedto: assignedTo, isSpinner: false });
        resolve();

      })
      .catch((error) => {

        reject();
      });
  };

  GetItemlist = (requestlist: any) => {

    let inventorydata: any = [];

    let TypeInventory: any = [];
    let TypeUserlist: any = [];

    inventorydata = Object.assign([], JSON.parse(JSON.stringify(this.state.inventorydata)));

    JobServices.GetInventoryData(requestlist)
      .then(async (resultinv: any | null) => {

        if (resultinv !== null) {
          resultinv.forEach(element => {

            let value = element.product_name + (element.inventory_description != null && element.inventory_description.length > 0 ? " ( " + element.inventory_description + " )" : "");
            let item: any = {};
            item.id = element.product_id;
            item.itemname = value;
            item.label = value;
            item.selectitem = element.product_name;
            item.glcode = element.glcode;
            item.stockqty = element.stockqty,
              // + "-" + element.category_name + "-" + element.producttype_name + " (" + element.sizedesc + " )";
              item.description = element.inventory_description;
            item.qty = element.quantity_in_stock;
            item.unitPrice = 0;
            item.unit = element.unit;
            TypeInventory.push(item);

          });

          inventorydata = TypeInventory;




          let itemdetailsdata: any = [];
          let newRow: any = {};
          let iteminventorydata: any = [];
          iteminventorydata = Object.assign([], JSON.parse(JSON.stringify(this.state.itemListdatam)));

          itemdetailsdata = Object.assign([], JSON.parse(JSON.stringify(this.state.itemdetailsdata)));



          this.setState({ itemdetailsdata: [] }, () => {
            this.setState({ itemdetailsdata: itemdetailsdata });

          });





          this.setState({ inventorydata: [], itemdetailsdata: [] }, () => {
            this.setState({ inventorydata: inventorydata, itemdetailsdata: itemdetailsdata, });

          });


        }
        resolve();

      })
      .catch((error) => {

        reject();
      });

  };


  getProcessTemplate = (requestlist: any) => {

    let Typelistprocessm: any = [];
    let customerTemplates: any = [];
    PartTemplateService.GetPartTemplatelist(requestlist)
      .then(async (result: any | null) => {

        if (result !== null) {
          result.forEach(element => {
            let item: any = {};
            let item1: any = {};

            item.id = element.id;
            item.name = element.tname;
            Typelistprocessm.push(item);

            if(element.templateMappingCustomer.length > 0 && element.status === "Active"){
              item1.id = element.id;
              item1.template_name = element.tname;
              item1.customerList = element.templateMappingCustomer;
              customerTemplates.push(item1);
            }
          });

   
          this.setState({
            templatelistitem: Typelistprocessm,
            customerTemplates
          },
            () => {
               if (this.state.templatelistitem.length > 0)
               {
              // var prid= this.state.templatelistitem.filter(x => x.name === "Custom");
              var prid = this.state.templatelistitem?.find(x => x.name === "Custom")?.id || 0;
              this.getTemplateData(prid);
              // this.Getjoblist(requestlist);
               }
              this.Getjoblist(requestlist);

            });
        }

        resolve();

      })
      .catch((error) => {

        reject();
      });


  };

  getassigntodata = (requestlist: any) => {
    let tenantName = storage === null ? '' : `${storage.firstName} ${storage.lastName}`; 
    let TypeUserlist: any = [];
    let assignedto = "";
    User.getAllUsers()
      .then(async (result: any | null) => {

        if (result !== null) {

          result.forEach(element => {
            let item: any = {};
            item.id = element.user_UniqueID;
            item.name = element.userName;

            // if (element.role == "1") {
            //   if (this.state.assignedto == "" || assignedto == "") {
            //     assignedto = element.userName;
            //   }
            // };
            TypeUserlist.push(item);
          });



          this.setState({ assigneddatatoList: TypeUserlist, assignedto: tenantName });


        }
        resolve();

      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });

      this.getProcessTemplate(requestlist);

   

  };

  getjobdata = (id: any = []) => {
    let processdataList: any = [];
    let requestlist = { ...this.state.requestlist };
    this.setState({processLoad:false});

    PartTemplateService.GetProcessList(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {

          result.forEach(element => {

            let item: any = {};
            item.srno = element.srno;
            item.id = element.id;
            item.name = element.processName;
            item.description = element.pDescription;
            item.isFixed = element.isFixed;
            item.tenantid = element.tenantid;
            item.status = element.status;

            processdataList.push(item);
            //Typelistprocess.push(item);
          });
          this.setState({
            processdataList: processdataList,

          },
            () => {


              let requestlist = { ...this.state.requestlist };
              this.getPartDataforPopup("","");
             
              this.GetItemlist(requestlist);
              this.getassigntodata(requestlist);
              // this.setState({ processdataList: [], }, () => {
              //   this.setState({
                
              //     processdataList: processdataList,


              //   });

              // });

            });
         



        }
        resolve();
      })
    .catch((error) => {

      reject();
    })
      .finally(() => {
      this.setState({ processLoad: true });
      });


  };


  updateJobDetailsData = () => {
    let updatedJobDetails = this.state.jobdetailsdata.map((jobDetail: any) => {
      const updatedJobDetail = {
        ...jobDetail,
        processList: this.state.processdataList,
      };
      return updatedJobDetail;
    });
  console.log("updated---------",updatedJobDetails);
    // this.setState({ jobdetailsdata: updatedJobDetails });
    this.setState({ jobdetailsdata: [] }, () => {
      this.setState({ jobdetailsdata: updatedJobDetails });
    });
  };

  getRefreshjobdata = (id: any = []) => {
    let processdataList: any = [];
    let requestlist = { ...this.state.requestlist };


    PartTemplateService.GetProcessList(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {

          result.forEach(element => {

            let item: any = {};
            item.srno = element.srno;
            item.id = element.id;
            item.name = element.processName;
            item.description = element.pDescription;
            item.isFixed = element.isFixed;
            item.tenantid = element.tenantid;
            item.status = element.status;

            processdataList.push(item);
          });
          this.setState({ processdataList: processdataList }, () => {
            this.updateJobDetailsData();
          });
          // console.log("--------------",this.state.jobdetailsdata);
        }
        resolve();
      });
    
  };

  getProcessDataforPopup = (id: any = []) => {
  
    let jobdetailsdata: any = [];

    let request: any = {};
    request.id = id;
    PartTemplateService.GetTemplatedata(request)
      .then(async (result: any | null) => {
        if (result !== null) {       
          let orderArray: any = [];
          orderArray = result[0].tDetails;
         
        
          if (orderArray.length > 0) {
            orderArray.forEach((element, idx) => {
              let filterRow = this.state.processdataList.filter(x => x.id === orderArray[idx].processid);
              if (filterRow.length > 0) {
                let result = filterRow[0]; 

                element.processList = this.state.processdataList;
                element.processName = result.name;  
                element.processid = orderArray[idx].processid;
                element.jDescription = element.tdescription;
                element.processOrder = idx + 1;
          
                jobdetailsdata.push(element);
              }
            });
          }
          
                 
              this.setState({ processData: [], }, () => {
                this.setState({
                  processData: jobdetailsdata,

                });

              });
        }
      
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  getProcessDatabyPartJobForPopup = (id: any = []) => {
    
    let jobdetailsdata: any = [];
    let newRow = this.state.newRow;
    let request: any = {};
    request.jobId = id;
    PartTemplateService.GetProcessDataByJobId(request)
      .then(async (result: any | null) => {
        if (result !== null) {
       
          let orderArray: any = [];
          orderArray = result;
          if (orderArray.length > 0) {
            orderArray.forEach((element, idx) => {
              let filterRow = this.state.processdataList.filter(x => x.id === orderArray[idx].processId);
              element.srno = idx + 1;
              element.processList = this.state.processdataList;
              element.processName = filterRow[0].name;
              element.processid = orderArray[idx].processId;
              element.tdescription = filterRow[0].description;

              element.jDescription = filterRow[0].description;

              element.processOrder = idx + 1;
              jobdetailsdata.push(element);
            });
          }
         // this.setState({ processData: jobdetailsdata,isSpinner:false});

         
         this.setState({ processData: [], }, () => {
          this.setState({
            processData: jobdetailsdata,
            isPopupSpinner:false,
          });

        });
        }
      
        resolve();
      })
      .catch((error) => {
        this.setState({ isPopupSpinner: false });
        reject();
      });
  };

   getTemplateData = (id: any = []) => {
    let jobdetailsdata: any = []; 
    let newRow = this.state.newRow;
    // jobdetailsdata = Object.assign([], JSON.parse(JSON.stringify(this.state.jobdetailsdata)));
    let saveRequest: any = {};
    saveRequest.id = id;
    let formData = { ...this.state.formData };
    saveRequest.tenantid = 0;
    PartTemplateService.GetTemplatedata(saveRequest)
      .then(async (result: any | null) => {
        if (result !== null && result.length > 0) {
          let defaultper = result[0].tname;
          //formData.templatename = result[0].templatename;
          formData.tname = defaultper;
          let orderArray: any = [];
          orderArray = result[0].tDetails;
          if (orderArray.length > 0) {
            orderArray.forEach((element, idx) => {
              let filterRow = this.state.processdataList.filter(x => x.id === orderArray[idx].processid);

              element.processList = this.state.processdataList;
              // element.processName = filterRow[0].name;
              // element.processid = orderArray[idx].processid;
              // element.tdescription = filterRow[0].description;
              // element.jDescription = filterRow[0].description;
              // element.processOrder = idx + 1;

              element.processName = "Select";
              element.processid = 0;
              element.tdescription = "";
              element.jDescription = "";
              element.processOrder = 0;
              element.qty = 0;
              jobdetailsdata.push(element);
              //          let requestlist = { ...this.state.requestlist };
              //            this.GetTempateType(requestlist);
            });
            newRow.forEach(element => {
              element.processList = this.state.processdataList;
              // element.processName = filterRow[0].name;
              // element.processid = orderArray[idx].processid;

            });
          }

          this.setState({
            jobdetailsdata: jobdetailsdata,
            formData: formData,
          },
            () => {
              this.setState({ jobdetailsdata: [], }, () => {
                this.setState({
                  jobdetailsdata: jobdetailsdata,

                });

              });
             
            });



        }else{
  let updatedFirst = {
              ...this.state.jobdetailsdata[0],
              processName: "Select",
              processid: 0,
              tdescription: "",
              jDescription: "",
              processOrder: 0,
              processList: this.state.processdataList,
            };

            jobdetailsdata = [
              updatedFirst,
              ...this.state.jobdetailsdata.slice(1)
            ];

        
        this.setState(
          {
            jobdetailsdata: jobdetailsdata,
          },
          () => {
            this.setState({ jobdetailsdata: [] }, () => {
              this.setState({
                jobdetailsdata: jobdetailsdata,
              });
        });

      });

    }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSaveSpinner: false });
        reject();
      });
  };

  getPartDataforPopup = (searchby: any,type:any ) => {
    
    let partData: any = [];
    let request: any = {};
    request.searchby = searchby;
    request.type=type;
    PartTemplateService.GetPartdata(request)
      .then(async (result: any | null) => {
        if (result !== null) {
          
          if (result.length > 0) {
            result.forEach((element, idx) => {
              let item:any = {};
              item.srno = idx + 1;
              item.partName = element.partName;
              item.jobid = element.jobid;
              item.tenantId = element.tenantid;
              item.jobNo = element.jobNo;
              partData.push(element);
            });
          }
          this.setState({ partData: partData });
        }
      
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  // GetUploadFileList = (uniqueNo, type) => {
  //       let requestlist: any = {};
  //       requestlist.orderid = this.state.orderid;
  //       requestlist.transactionID = this.state.formData.jobid > 0? this.state.formData.jobid:uniqueNo;
  //       requestlist.transactionType = "jobOrder";
    
  //       TransactionService.GetUploadFileWithFileCodeTransaction(requestlist)
  //         .then(async (result: any | null) => {
  //           if (result.length > 0) {
  //             for (let i = 0; i < result.length; i++) {
  //               this["myRef" + i] = React.createRef();
  //             }
  //             let filelist: any[] = [];
  //             result.forEach((element, i) => {
  //               element.fileCode =
  //                 "data:application/pdf;base64," + element.fileCode;
  //               element.fileName = element.name;
  //               element.newname = element.name.toString().toLowerCase();
  //               filelist.push(element);
  //             });
  //             //filelist = _.sortBy(filelist, "newname");
  //             this.setState({savedfiles:[]}, () => {
  //               this.setState(
  //                 (prevState) => ({
  //                   savedfiles: filelist,
  //                   isAttachmentLoading: false,
  //                   isOpenViewer: false,
  //                   newSelectedfiles: [],
  //                   files: [],
  //                   bulkSelect: true,
  //                 }),
  //                 () => {
  //                   setTimeout(() => {
  //                     this.scrollheight.current?.getElement().scrollTo({
  //                       top: Number(this.state.currentScreenTop),
  //                       behavior: "smooth",
  //                     });
  //                   }, 500);
  //                 }
  //               );
  //             }
    
    
  //             );
             
            
  //           } else {
  //             this.setState({
  //               isOpenViewer: false,
  //               savedfiles: [],
  //               newSelectedfiles: [],
  //               files: [],
  //               bulkSelect: false,
  //             });
  //           }
    
  //           resolve();
  //         })
  //         .catch((error) => {
  //           reject();
  //           this.setState({
  //             isOpenViewer: false,
  //             savedfiles: [],
  //             newSelectedfiles: [],
  //             files: [],
  //             bulkSelect: false,
  //           });
  //         });
  //     };

  GetUploadFileList = (uniqueNo, type) => {
  let jobOrderRequest: any = {};
  jobOrderRequest.orderid = this.state.orderid;
  jobOrderRequest.transactionID = this.state.formData.jobid > 0 ? this.state.formData.jobid : uniqueNo;
  jobOrderRequest.transactionType = "jobOrder";

  let customerOrderRequest: any = {};
  customerOrderRequest.orderid = this.state.customerorderid;

  this.setState({ isAttachmentLoading: true });

  Promise.all([
    TransactionService.GetUploadFileWithFileCodeTransaction(jobOrderRequest),
    CustomerService.GetUploadFileWithFileCode(customerOrderRequest)
  ])
    .then(([jobFiles = [], customerFiles = []]) => {
      let combinedFiles: any[] = [];

      const processFiles = (files: any[], source: string) => {
        return files.map((file) => ({
          ...file,
          fileCode: "data:application/pdf;base64," + file.fileCode,
          fileName: file.name,
          newname: file.name.toString().toLowerCase(),
          source: source
        }));
      };

      combinedFiles = [
        ...processFiles(jobFiles, "jobOrder"),
        ...processFiles(customerFiles, "customerOrder")
      ];

      combinedFiles.forEach((_, i) => {
        this["myRef" + i] = React.createRef();
      });

      this.setState({ savedfiles: [] }, () => {
        this.setState(
          {
            savedfiles: combinedFiles,
            isAttachmentLoading: false,
            isOpenViewer: false,
            newSelectedfiles: [],
            files: [],
            bulkSelect: true,
          },
          () => {
            setTimeout(() => {
              this.scrollheight.current?.getElement().scrollTo({
                top: Number(this.state.currentScreenTop),
                behavior: "smooth",
              });
            }, 500);
          }
        );
      });
    })
    .catch((error) => {
      console.error("Error fetching files:", error);
      this.setState({
        isOpenViewer: false,
        savedfiles: [],
        newSelectedfiles: [],
        files: [],
        bulkSelect: false,
        isAttachmentLoading: false,
      });
    });
};


  onTAB = (control, rowIndex1, event) => {

    let controlID = control.split("-")[0];
    let rowIndex = Number(rowIndex1);

    let itemdetailsdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.itemdetailsdata))
    );
    let invdata = this.state.inventorydata.filter((x) => x.glcode.toLowerCase() === event.target.value.toLowerCase());

    if (event.key.toLowerCase() === "enter") {
      if (controlID === "txtOrderDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      }
      else if (controlID === "glcode") {
        let id = "txtunit" + rowIndex + "txt";
        let defaultitemname: any = [];
        itemdetailsdata[rowIndex].glcode = event.target.value;
        if (invdata.length > 0) {
          itemdetailsdata[rowIndex].itemname = itemdetailsdata[rowIndex].itemname == "" ? invdata[0].selectitem : itemdetailsdata[rowIndex].itemname;
          itemdetailsdata[rowIndex].itemid = invdata[0].id;
          itemdetailsdata[rowIndex].unitPrice = invdata[0].unitPrice;
          itemdetailsdata[rowIndex].unit = invdata[0].unit;

          defaultitemname = invdata;
          itemdetailsdata[rowIndex].defaultitemname = defaultitemname;
        }
        this.setState({ itemdetailsdata, defaultitemname }, () => {

          $("#tbltemplate")
            .find("input[id^='" + id + "']")
            .focus();
        });
      }
    }

    if (event.key.toLowerCase() === "tab") {
      
      //       let controlID = control.split("-")[0];
      //       let rowIndex = Number(rowIndex1);
      //       let itemdetailsdata = Object.assign(
      //         [],
      //         JSON.parse(JSON.stringify(this.state.itemdetailsdata))
      //       );
      //       let defaultitemname: any = [];
      //       let inventorydata = Object.assign(
      //         [],
      //         JSON.parse(JSON.stringify(this.state.inventorydata))
      //       );

      //       itemdetailsdata[rowIndex].itemname =itemdetailsdata[rowIndex].itemname =="" ? "" :itemdetailsdata[rowIndex].itemname ;
      //       itemdetailsdata[rowIndex].id = 0;
      //       itemdetailsdata[rowIndex].glcode =event.target.value;
      //       itemdetailsdata[rowIndex].stockqty = 0;
      //       itemdetailsdata[rowIndex].unit = "";
      //       itemdetailsdata[rowIndex].unitPrice = 0;

      //       itemdetailsdata[rowIndex].description = "";

      //       let objPartname: any = {};
      //       objPartname.itemname = event.target.value;
      //       objPartname.label = event.target.value;
      //       objPartname.id = 0;
      //       objPartname.glcode = "";
      //       objPartname.stockqty = 0;
      //       objPartname.unit = "";

      //       objPartname.tenantid = 0;

      //       objPartname.unitPrice = 0;

      //       objPartname.description = "";
      //       defaultitemname.push(objPartname);
      //       inventorydata.push(objPartname);


      //       itemdetailsdata[rowIndex].defaultitemname = defaultitemname;

      //       let ChecktxtID = "itemname" + rowIndex + "ddl";
      // 
      //       if (controlID === ChecktxtID) {
      //         let txtID = "txtglcode" + rowIndex + "txt";

      //         $("#tbltemplate")
      //           .find("input[id^='" + txtID + "']")
      //           .focus();
      //       }

      if (controlID === "txtduedate") {
        let txtID = "txtdescription" + rowIndex + "txt";

        $("#tbltemplate")
          .find("input[id^='" + txtID + "']")
          .focus();
      }

      if (controlID === "txtOrderDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      }
      else if (controlID === "glcode") {

        // let id = "txtunit" + rowIndex + "txt";
        // let defaultitemname: any = [];
        // itemdetailsdata[rowIndex].glcode = event.target.value;
        // if (invdata.length > 0) {
        //   itemdetailsdata[rowIndex].itemname = invdata[0].selectitem;
        //   itemdetailsdata[rowIndex].itemid = invdata[0].id;
        //   itemdetailsdata[rowIndex].unitPrice = invdata[0].unitPrice;
        //   itemdetailsdata[rowIndex].unit = invdata[0].unit;

        //   defaultitemname = invdata;
        //   itemdetailsdata[rowIndex].defaultitemname = defaultitemname;
        // }
        // this.setState({ itemdetailsdata, defaultitemname }, () => {

        // });
      }
    }

    if (event.key.toLowerCase() === "backspace") {

      let controlID = control.split("-")[0];

      if (controlID === "itemname") {
        let itemdetailsdata = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.itemdetailsdata))
        );
        let defaultitemname: any = [];
        let inventorydata = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.inventorydata))
        );

        itemdetailsdata[rowIndex].itemname = "";
        //   itemdetailsdata[rowIndex].itemname;
        itemdetailsdata[rowIndex].id = 0;
        itemdetailsdata[rowIndex].glcode = event.target.value;
        itemdetailsdata[rowIndex].stockqty = 0;
        itemdetailsdata[rowIndex].unit = "";
        itemdetailsdata[rowIndex].unitPrice = 0;

        itemdetailsdata[rowIndex].description = "";

        let objPartname: any = {};
        objPartname.itemname = event.target.value;
        objPartname.label = event.target.value;
        objPartname.id = 0;
        objPartname.glcode = "";
        objPartname.stockqty = 0;
        objPartname.unit = "";

        objPartname.tenantid = 0;

        objPartname.unitPrice = 0;

        objPartname.description = "";
        defaultitemname.push(objPartname);
        // inventorydata.push(objPartname);


        itemdetailsdata[rowIndex].defaultitemname = defaultitemname;

        this.setState(
          { itemdetailsdata, defaultitemname, inventorydata },
          () => {




            let txtID = "rbt-input-main form-control rbt-input rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex + "ddl";
            $("input[class^='" + txtID + "']").focus();

          }
        );
        // this.setState({ itemdetailsdata, defaultitemname, inventorydata }, () => {
        //   
        //   let txtID ="rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex +"ddl";
        //   $("input[class^='" + txtID + "']").focus();
        //   // let txtID =
        //   //   "rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex + "ddl";
        //   // $("#tbltemplate")
        //   //   .find("input[class^='" + txtID + "']")
        //   //   .focus();
        // });

      }
    }
  };

   handleEditClick1 = (rowIndex, currentDesc) => {
   
    this.setState({
      editingIndex: rowIndex,
      currentNote: currentDesc,
      showPopup1: true,
    });
  };

  handleNotesSave1 = () => {

  let itemdetailsdata = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.itemdetailsdata))
      );

    const { editingIndex, currentNote } = this.state;
    itemdetailsdata[editingIndex].materialDesc = currentNote;
    this.setState({ showPopup1: false, editingIndex: null, currentNote: '' ,itemdetailsdata, isStateChanged: true});
  };


    handleEditClick = (rowIndex, jDescription) => {
    
      this.setState({
        editingIndex: rowIndex,
        currentNote: jDescription,
        showPopup: true,
      });
    };

    handleNotesSave = () => {

      let jobdetailsdata = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.jobdetailsdata))
      );

      const { editingIndex, currentNote } = this.state;
      console.log("noteee",currentNote.split('\n')[0]);
      jobdetailsdata[editingIndex].jDescription = currentNote;
      this.setState({ showPopup: false, editingIndex: null, currentNote: '' ,jobdetailsdata, isStateChanged: true});
    };


    handleOutsideClick = (rowIndex: any, e: any) => {
      
      let btnId = "itemname" + rowIndex + "btn";
      let id = "itemname" + rowIndex + "ddl";
      let relatedTargetID = e.relatedTarget?.id;
      let itemdetailsdata = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.itemdetailsdata))
      );
      let defaultitemname: any = [];
      let inventorydata = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.inventorydata))
      );

      itemdetailsdata[rowIndex].itemname = e.target.value;
      itemdetailsdata[rowIndex].id = 0;
      itemdetailsdata[rowIndex].glcode = itemdetailsdata[rowIndex].glcode;
      itemdetailsdata[rowIndex].stockqty = 0;
      itemdetailsdata[rowIndex].unit = "";
      itemdetailsdata[rowIndex].unitPrice = 0;

      itemdetailsdata[rowIndex].description = "";

      if (e.target.value != "") {
        let objPartname: any = {};
        objPartname.itemname = e.target.value;
        objPartname.label = e.target.value;
        objPartname.id = 0;
        objPartname.glcode = "";
        objPartname.stockqty = 0;
        objPartname.unit = "";

        objPartname.tenantid = 0;

        objPartname.unitPrice = 0;

        objPartname.description = "";
        defaultitemname.push(objPartname);
        inventorydata.push(objPartname);




        itemdetailsdata[rowIndex].defaultitemname = defaultitemname;

        this.setState({ itemdetailsdata, defaultitemname, inventorydata }, () => {


        });
      }
      else {
        let itemdetailsdata = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.itemdetailsdata))
        );
        this.setState({ itemdetailsdata: [] }, () =>
          this.setState({ itemdetailsdata }, () => {
          })
        );
      }
      
      $("#tbltemplate")
        .find("button[id^='" + btnId + "']")
        .css("display", "none");
      $("#tbltemplate")
        .find("div[id^='" + id + "']")
        .css("display", "none");
      setTimeout(() => {
        if (relatedTargetID === undefined) {
          // setTimeout(() => {

          //   let txtID1 = "txtduedate" + rowIndex + "txt";
          //       $("#tbltemplate")
          //         .find("input[id^='" + txtID1 + "']")
          //         .focus();
          // }, 50);

        } else if (
          relatedTargetID ===
          "rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex + "ddl"
        ) {
          
          // let txtID1 =
          //   "rbt-input-main form-control rbt-input form-control form-control itemname" +rowIndex + "ddl";
          // $("#tbltemplate")
          //   .find("input[class^='" + txtID1 + "']")
          //   .focus();
          let txtID = "rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex + "ddl";
          $("input[class^='" + txtID + "']").focus();
        } else if (relatedTargetID === "txtglcode" + rowIndex + "txt") {
          let txtID1 = "txtglcode" + rowIndex + "txt";
          $("#tbltemplate")
            .find("input[id^='" + txtID1 + "']")
            .focus();
        } else if (relatedTargetID === "txtunit" + rowIndex + "txt") {
          let txtID1 = "txtunit" + rowIndex + "txt";
          $("#tbltemplate")
            .find("input[id^='" + txtID1 + "']")
            .focus();
        } else if (relatedTargetID === "txtstockqty" + rowIndex + "txt") {
          let txtID1 = "txtstockqty" + rowIndex + "txt";
          $("#tbltemplate")
            .find("input[id^='" + txtID1 + "']")
            .focus();
        } else if (relatedTargetID === "txtreqqty" + rowIndex + "txt") {
          let txtID1 = "txtreqqty" + rowIndex + "txt";
          $("#tbltemplate")
            .find("input[id^='" + txtID1 + "']")
            .focus();
        } else if (relatedTargetID === "txtqty" + rowIndex + "txt") {
          let txtID1 = "txtqty" + rowIndex + "txt";
          $("#tbltemplate")
            .find("input[id^='" + txtID1 + "']")
            .focus();
        } else if (relatedTargetID === "txtunitprice" + rowIndex + "txt") {
          let txtID1 = "txtunitprice" + rowIndex + "txt";
          $("#tbltemplate")
            .find("input[id^='" + txtID1 + "']")
            .focus();
        } else if (relatedTargetID === "txtdiscount" + rowIndex + "txt") {
          let txtID1 = "txtdiscount" + rowIndex + "txt";
          $("#tbltemplate")
            .find("input[id^='" + txtID1 + "']")
            .focus();
        } else if (relatedTargetID === "txttotal" + rowIndex + "txt") {
          let txtID1 = "txttotal" + rowIndex + "txt";
          $("#tbltemplate")
            .find("input[id^='" + txtID1 + "']")
            .focus();
        }

      }, 50);



    };
  closeSlideOut = () => {
    this.props.closeSlideOut(this.state?.shouldReloadMainPage);

  };

  closeSlideOut3 = () => {
    this.setState({ showSlideout: false, isSpinner:false, });
};

openSlideout = () => {
  this.setState({showSlideout:true});
    
};


  closeSlideOut2 = () => {

    this.setState({ showVSlideout: false, isSpinner: false, });
    this.getjobdata();
  };

   closeSlideOutOrder = () => {

    this.setState({ showOrderSlideout: false, isSpinner: false, });
    // this.getjobdata();
  };

   closeSlideOutPart = () => {

    this.setState({ showPartSlideout: false, isSpinner: false, });
    // this.getjobdata();
  };

  scrollToBottom = () => {

    /* this.parentScroll.current.scrollTo({
 
       //top: this.parentScroll.current.clientHeight,
       top: this.parentScroll.current.scrollHeight,
       behavior: "smooth",
     });*/
  };

  hoverOutEllipsis = () => {
    $(".tooltip").removeClass("show");
  };

  closeSlideOut1 = () => {

    this.props.closeSlideOut(this.state?.shouldReloadMainPage);
  };

  reopenSlideOutWithNextJob = () => {
    this.props.reopenSlideOutWithNextJob();
  };


  ishandleDeleteRow(row: any, mode: any) {
    if (mode) {
      
      let jobdetails = Object.assign([], JSON.parse(JSON.stringify(this.state.jobdetailsdata)));

      this.setState({ jobdetails: [] }, () => {
        

        const jobdetailsNewc = jobdetails.filter(item => item.srno !== row.srno).map((item, index) => {
          
          item.srno = index + 1;
          return item;
        });

        this.setState({
          jobdetailsdata: jobdetailsNewc,
          ischanged: 1,isStateChanged:true,

        },
          () => {


          });
      });
    }
  }

  handleItemDetailDeleteRow(row: any, mode: any) {
    if (mode) {

      let itemDetail = Object.assign([], JSON.parse(JSON.stringify(this.state.itemdetailsdata)));

      this.setState({ itemDetail: [] }, () => {


        const itemDetailNewc = itemDetail.filter(item => item.id !== row.id).map((item, index) => {
          //item.templateno = index + 1;
          return item;
        });

        this.setState({
          itemdetailsdata: itemDetailNewc,isStateChanged:true,
        },
          () => {


          });
      });
    }
  }
  handleSelectedItem = (control: any, id: any) => {

    let controlID = Number(control.split('_')[0]);

    console.log("handel id----",id);
    if (controlID === 2) {

      let rowIndex = Number(control.split('_')[1]);
      let jobdetailsdata = Object.assign([], JSON.parse(JSON.stringify(this.state.jobdetailsdata)));
      let filterRow = this.state.processdataList.filter(x => x.id === id);
      jobdetailsdata[rowIndex].type = filterRow[0].isFixed == 1 ? "Vendor" : "Work";

      jobdetailsdata[rowIndex].processName = filterRow[0].name;
      jobdetailsdata[rowIndex].processid = filterRow[0].id;
      jobdetailsdata[rowIndex].tdescription = filterRow[0].description;
      jobdetailsdata[rowIndex].jDescription = filterRow[0].description;
      //jobdetailsdata[rowIndex].type = filterRow[0].type;
      this.setState({ jobdetailsdata: [] }, () => {
        this.setState({ jobdetailsdata, ischanged: 1,isStateChanged:true }, () => {
          let txtID = 'ddlprocess-' + (rowIndex) + "ddl";
          $("#tbltemplate").find("button[id^='" + txtID + "']").focus();
        });
      });

    }
    else if (controlID === 3) {

    }
    else if (controlID === 5) {

      let rowIndex = Number(control.split('_')[1]);
      let itemdetailsdata = Object.assign([], JSON.parse(JSON.stringify(this.state.itemdetailsdata)));
      let filterRow = this.state.itemListdatam.filter(x => x.id === id);


      itemdetailsdata[rowIndex].itemname = filterRow[0].name;
      itemdetailsdata[rowIndex].description = filterRow[0].desc;
      itemdetailsdata[rowIndex].qty = filterRow[0].qty;
      itemdetailsdata[rowIndex].sizedesc = filterRow[0].sizedesc;


      //itemdetailsdata[rowIndex].assignedid = filterRow[0].id;

      this.setState({ itemdetailsdata: [] }, () => {
        this.setState({ itemdetailsdata: itemdetailsdata,isStateChanged:true });

      });
    } if (controlID === 6) {
      let type = id.split(':')[0];
      let typeId = Number(id.split(':')[1]);
      let rowIndex = Number(control.split('_')[1]);
      let jobdetailsdata = Object.assign([], JSON.parse(JSON.stringify(this.state.jobdetailsdata)));
      let filterRow = this.state.TypeUserlist.filter(x => x.id === id);

      //
      if(type === 'u')
      {
      this.state.jobdetailsdata[rowIndex].assignedid = typeId; //filterRow[0].id;
      this.state.jobdetailsdata[rowIndex].workstationid = 0; 

      }
      else
      {
      this.state.jobdetailsdata[rowIndex].workstationid = typeId; //filterRow[0].id;
      this.state.jobdetailsdata[rowIndex].assignedid = 0;
      }
      this.state.jobdetailsdata[rowIndex].assignedName = filterRow[0].name;

     /* this.setState({ jobdetailsdata: [] }, () => {
        this.setState({ jobdetailsdata }, () => {
          let txtID = 'ddlprocess-' + (rowIndex) + "ddl";
          $("#tbltemplate").find("button[id^='" + txtID + "']").focus();
        });
      });
      */
    }
  };

  handleSelectedItemInv = (control: any, id: any) => {
    if (this != undefined) {
      let isStateChanged = true;
      
      let formData = { ...this.state.formData };
      let controlID = Number(control.split("_")[0]);
      let rowIndex = Number(control.split("_")[1]);

      let itemdetailsdata = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.itemdetailsdata))
      );
      let defaultitemname: any = [];
      let inventorydata = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.inventorydata))
      );
     

      if (controlID === 1) {

        if (id.length > 0) {
          if (id[0].id > 0) {
            itemdetailsdata[rowIndex].itemname = id[0].selectitem;
            itemdetailsdata[rowIndex].id = id[0].id;
            itemdetailsdata[rowIndex].unitPrice = id[0].unitPrice;
            itemdetailsdata[rowIndex].unit = id[0].unit;
            itemdetailsdata[rowIndex].glcode = id[0].description;
            itemdetailsdata[rowIndex].stockqty = id[0].stockqty;

            itemdetailsdata[rowIndex].unit = id[0].unit;

            itemdetailsdata[rowIndex].description = id[0].description;

            let objPartname: any = {};
            objPartname.itemname = id[0].selectitem;
            objPartname.label = id[0].selectitem;
            objPartname.id = id[0].id;
            objPartname.glcode = id[0].glcode;
            objPartname.stockqty = id[0].stockqty;
            objPartname.unitPrice = id[0].unitPrice;
            objPartname.unit = id[0].unit;
            objPartname.tenantid = 0;

            objPartname.description = id[0].description;
            defaultitemname.push(objPartname);

            itemdetailsdata[rowIndex].defaultitemname = defaultitemname;
            this.setState(
              { itemdetailsdata, defaultitemname, inventorydata, isStateChanged },
              () => {



                // 
                // let txtID ="rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex +"ddl";
                // $("input[class^='" + txtID + "']").focus();

              }
            );
            // this.setState(
            //   { itemdetailsdata, defaultitemname, inventorydata, isStateChanged },
            //   () => {

            //     let txtID = "txtglcode" + rowIndex + "txt";
            //     $("#tbltemplate")
            //       .find("input[id^='" + txtID + "']")
            //       .focus();
            //   }
            // );
          } else {
            itemdetailsdata[rowIndex].itemname = id[0].label;
            itemdetailsdata[rowIndex].id = 0;
            itemdetailsdata[rowIndex].glcode = "";
            itemdetailsdata[rowIndex].stockqty = 0;
            itemdetailsdata[rowIndex].unit = "";
            itemdetailsdata[rowIndex].unitPrice = 0;

            itemdetailsdata[rowIndex].description = "";

            let objPartname: any = {};
            objPartname.itemname = id[0].label;
            objPartname.label = id[0].label;
            objPartname.id = 0;
            objPartname.glcode = "";
            objPartname.unit = "";
            objPartname.stockqty = 0;

            objPartname.tenantid = 0;

            objPartname.unitPrice = 0;

            objPartname.description = "";
            defaultitemname.push(objPartname);
            inventorydata.push(objPartname);


            itemdetailsdata[rowIndex].defaultitemname = id;
            this.setState(
              { itemdetailsdata, defaultitemname, inventorydata, isStateChanged },
              () => {



                // 
                // let txtID ="rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex +"ddl";
                // $("input[class^='" + txtID + "']").focus();

              }
            );
            // this.setState(
            //   { itemdetailsdata, defaultitemname, inventorydata, isStateChanged },
            //   () => {

            //     let txtID = "txtglcode" + rowIndex + "txt";
            //     $("#tbltemplate")
            //       .find("input[id^='" + txtID + "']")
            //       .focus();
            //   }
            // );
          }
        } else {

          itemdetailsdata[rowIndex].itemname = "";
          itemdetailsdata[rowIndex].id = 0;
          itemdetailsdata[rowIndex].glcode = "";
          itemdetailsdata[rowIndex].stockqty = 0;
          itemdetailsdata[rowIndex].unit = "";
          itemdetailsdata[rowIndex].unitPrice = 0;

          itemdetailsdata[rowIndex].description = "";

          let objPartname: any = {};
          objPartname.itemname = "";
          objPartname.label = "";
          objPartname.id = 0;
          objPartname.glcode = "";
          objPartname.unit = "";
          objPartname.stockqty = 0;
          objPartname.tenantid = 0;

          objPartname.unitPrice = 0;

          objPartname.description = "";
          defaultitemname.push(objPartname);
          //inventorydata.push(objPartname);

          //element.defaultPartname = defaultPartname;
          itemdetailsdata[rowIndex].defaultitemname = id;
          this.setState(
            { itemdetailsdata, defaultitemname, inventorydata, isStateChanged },
            () => {



              // 
              // let txtID ="rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex +"ddl";
              // $("input[class^='" + txtID + "']").focus();

            }
          );

        }


      }
      
      this.setState(
        { itemdetailsdata,defaultitemname, inventorydata, isStateChanged },
        () => {



          
          let txtID = "rbt-input-main form-control rbt-input form-control form-control itemname" + rowIndex + "ddl";
          $("input[class^='" + txtID + "']").focus();

        }
      );
    }
  };

  handleSelectedItem1 = (control: any, id: any) => {

    if (control == 2) {

      let assignTo = this.state.assigneddatatoList.filter((x) => x.id == id);
      let assignToName = assignTo.length > 0 ? assignTo[0].name : '';
      this.setState({ jobassignedid: id, assignedto: assignToName });
    }
    else if (control == 'JobNoList') {

      let jobno = this.state.jobMaster.filter((x) => x.id == id);
      debugger;
      this.setState({ isSpinner: true,jobid:id,jobNo: jobno[0].name });
      this.state.formData.jobid = id;
      
      this.GetJobDataByIdOnly();
    }
    else {

      let processes = this.state.templatelistitem.filter((x) => x.id == id);
      let processName = processes.length > 0 ? processes[0].name : '';
      this.setState({ jobprocessid: id, jobprocess: processName });
      this.getTemplateData(id);
      // this.getjobdata(id);    
    }
  };
  updateState = (e: any, index: any, type: any, txtID) => {
    if (this != undefined) {
      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;

      let itemdetailsdata = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.itemdetailsdata))
      );

      let jobdetailsdata = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.jobdetailsdata))
      );
      if (type === "glcode") {
        e.preventDefault();
        let defaultitemname: any = [];

        itemdetailsdata[index].glcode = e.target.value;

        this.setState({ itemdetailsdata, defaultitemname, isStateChanged }, () => {
          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "description") {
        
        e.preventDefault();

        jobdetailsdata[index].jDescription = e.target.value;

        this.setState({ jobdetailsdata, isStateChanged }, () => {
          $("#tbltemplate2")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate2").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }

        });
      }
      else if (type === "unitPrice") {
        e.preventDefault();
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        itemdetailsdata[index].unitPrice = e.target.value;

        this.setState({ itemdetailsdata, isStateChanged }, () => {
          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "orderqty") {
        e.preventDefault();
        let newVal = e.target.value.replace(/[^0-9\s]/g, ''); 
         e.target.value = newVal;
        itemdetailsdata[index].orderqty = e.target.value;

        this.setState({ itemdetailsdata, isStateChanged }, () => {
          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      else if (type === "reqqty") {
        e.preventDefault();
        let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        e.target.value = newVal;

        itemdetailsdata[index].qty = e.target.value;

        if (itemdetailsdata[index].stockqty != "" && itemdetailsdata[index].stockqty != undefined) {
          var orderqty = e.target.value - itemdetailsdata[index].stockqty;
          if (orderqty > 0) {
            itemdetailsdata[index].orderqty = orderqty;
          }
        }
        else {
          itemdetailsdata[index].orderqty = newVal;

        }
        this.setState({ itemdetailsdata, isStateChanged }, () => {
          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      else if (type === "unit") {
        e.preventDefault();

        itemdetailsdata[index].unit = e.target.value;

        this.setState({ itemdetailsdata, isStateChanged }, () => {
          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

  else if (type === "materialDesc") {
         e.preventDefault();
        let defaultitemname: any = [];

        itemdetailsdata[index].materialDesc = e.target.value;

        this.setState({ itemdetailsdata, defaultitemname, isStateChanged }, () => {
          $("#tbltemplate")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      else if (type === "qty") {
          e.preventDefault();
        let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        e.target.value = newVal;

         if (parseInt(e.target.value) > parseInt(this.state.qtyOrdered)) {
                toast.error("Qty completed should be less that qty ordered.", {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "OrderSlideout",
                });
              jobdetailsdata[index].qty = 0;

              }else{
             jobdetailsdata[index].qty = e.target.value;
              }

        this.setState({ jobdetailsdata, isStateChanged }, () => {
          $("#tbltemplate2")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tbltemplate2").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }

        });
      }


    }
  };

  onAmountFocus = (e, index, txtID,type: any) => {
    
    let itemdetailsdata = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.itemdetailsdata))
    );

    //let newval = Utils.removecurrencyFormat(e.target.value);
    let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
    if (type === "unitPrice") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      itemdetailsdata[index].unitPrice = e.target.value;

      this.setState({ itemdetailsdata }, () => {
        $("#tbltemplate")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tbltemplate").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }

    if (type === "discount") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      itemdetailsdata[index].discount =  e.target.value;

      this.setState({ itemdetailsdata }, () => {
        $("#tbltemplate")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tbltemplate").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }
    
   
    // this.setState({ orderData }, () => {
    //     $("#tbltemplate").find("input[id^='" + txtID + "']").focus();
    // });
};

amountBlur = (e, rowIndex, type: any) => {
    
  let itemdetailsdata = Object.assign(
    [],
    JSON.parse(JSON.stringify(this.state.itemdetailsdata))
  );

  if (e.target.value.includes(".")) {
    const timeArray = e.target.value?.split(".");
    if (timeArray[1].length <= 0) {
      if (type === "unitPrice") {
        itemdetailsdata[rowIndex].unitPrice = Utils.currencyFormat(
          timeArray[0]
        ); //Number(timeArray[0]).toFixed(2);
      }
      if (type === "discount") {
        itemdetailsdata[rowIndex].discount = Utils.currencyFormat(
          timeArray[0]
        ); //Number(timeArray[0]).toFixed(2);
      }
      if (type === "qtyOrdered") {
        itemdetailsdata[rowIndex].qtyOrdered = Utils.currencyFormatWithOutdoller(
          timeArray[0]
        ); //Number(timeArray[0]).toFixed(2);
      }
    } else {
      if (type === "unitPrice") {
        itemdetailsdata[rowIndex].unitPrice = Utils.currencyFormat(
          e.target.value
        );
      }
      if (type === "discount") {
        itemdetailsdata[rowIndex].discount = Utils.currencyFormat(
          e.target.value
        );
      }
      if (type === "qtyOrdered") {
        itemdetailsdata[rowIndex].qtyOrdered = Utils.currencyFormatWithOutdoller(
          e.target.value
        );
      }
    }

    this.setState({ itemdetailsdata });
  } else {
    if (type === "unitPrice") {
      itemdetailsdata[rowIndex].unitPrice =
        e.target.value === ""
          ? ""
          : !isNaN(e.target.value)
            ? Utils.currencyFormat(e.target.value)
            : e.target.value;
    }
    if (type === "discount") {
      itemdetailsdata[rowIndex].discount =
        e.target.value === ""
          ? ""
          : !isNaN(e.target.value)
            ? Utils.currencyFormatWithOutdoller(e.target.value)
            : e.target.value;
    }
    this.setState({ itemdetailsdata });
  }
};
  handleNewRow = () => {

    let jobdetailsdata: any = [];
    let newRow: any = {};
    let isStateChanged = true;
    
    jobdetailsdata = Object.assign([], JSON.parse(JSON.stringify(this.state.jobdetailsdata)));
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));
    let maxValueOfRow = jobdetailsdata.length ? Math.max(...jobdetailsdata.map(o => o.srno)) : 0;
    let len = jobdetailsdata.length;
    let maxRno = maxValueOfRow;
    let maxSrno = jobdetailsdata[len - 1]?.srno?jobdetailsdata[len - 1].srno:maxRno;
    let lastprocessid = jobdetailsdata[len - 1]?.srno+1 ? jobdetailsdata[len - 1].srno+1 : maxRno+1;
    newRow[0].srno = Number(maxSrno) + 1;
    newRow[0].processOrder = newRow[0].srno;
    // let filterRow = this.state.processdataList.filter(x => x.srno === lastprocessid);
console.log("poppppp",jobdetailsdata);

    // mapping api srno
    // if (filterRow.length != 0) {
    //   newRow[0].tdescription = filterRow[0].description;
    //   newRow[0].jDescription = filterRow[0].description;
    //   newRow[0].processName = filterRow[0].name;
    //   newRow[0].processid = filterRow[0].id;
    // }
    // else
    // {
    //   let filterRow = this.state.processdataList.filter(x => x.srno ===1);
    //   if (filterRow.length != 0) {
    //           newRow[0].tdescription = filterRow[0].description;
    //           newRow[0].jDescription = filterRow[0].description;
    //           newRow[0].processName = filterRow[0].name;
    //           newRow[0].processid = filterRow[0].id;
    //         }
    // }
              newRow[0].srno = 1; 
              newRow[0].processOrder = 1;
              newRow[0].tdescription = "";
              newRow[0].jDescription = "";
              newRow[0].processName = "";
              newRow[0].processid = "";
    jobdetailsdata.push(newRow[0]);

    //  jobdetailsdata.unshift(newRow[0]);

    jobdetailsdata = jobdetailsdata.map((row, index) => ({
      ...row,
      srno: index + 1,
      processOrder: index + 1
    }));

    this.setState({ jobdetailsdata: [] }, () => {
      this.setState({ jobdetailsdata: jobdetailsdata, isStateChanged, ischanged: 1 });

    });




  };

  handleNewRowitems = () => {
    let itemdetailsdata: any = [];
    let newRow: any = {};
    let isStateChanged = true;
    let iteminventorydata: any = [];
    iteminventorydata = Object.assign([], JSON.parse(JSON.stringify(this.state.itemListdatam)));

    itemdetailsdata = Object.assign([], JSON.parse(JSON.stringify(this.state.itemdetailsdata)));
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.itemdetailsdatanew)));

    let maxValueOfRow = Math.max(...itemdetailsdata.map(o => o.itemNo), 0);
    let len = itemdetailsdata.length;

    let maxSrno = itemdetailsdata[len - 1].itemNo;
    newRow.itemNo = Number(maxSrno) + 1;
    newRow.itemListdata = iteminventorydata;

    itemdetailsdata.push(newRow);
    this.setState({ itemdetailsdata: [] }, () => {
      this.setState({ itemdetailsdata: itemdetailsdata, isStateChanged });

    });




  };
  updatedCommentItem = () => {
    let updatedItem: any = {};
    this.setState({ isSave: true });
    updatedItem.transcationDate = this.state.formData.transcationDate;
    updatedItem.vendorName = this.state.formData.vendorName;
    updatedItem.amountTotal = this.state.totalAmount;
    return updatedItem;
  };
  handleDiscard(postID) {
    this.setState({ isStateChanged: false }, () => {
      this.closeSlideOut();
    });
  }
  CommentModalClose = () => {
    let uniqueno = this.state.formData.uniqueno;
    this.handleDiscard(uniqueno);
  };

  Getpreviousjob=(e:any,type :any)=> {

if(e.target.value.length>2)
  {
    let start = e.target?.selectionStart;
    let end = e.target?.selectionEnd;
e.preventDefault();

this.getPartDataforPopup(e.target.value,type);
  }
  else
  {
if(e.target.value=="")
  {
    this.setState({ partData: [],processData :[] });

  }

  }

};

  handleTemplateButton = (type: any) => {
    if (type == 'yes')
      this.state.formData.templatename = this.state.templatename;
    else
      this.state.formData.templatename = '';

    this.savejob(0,0);
    this.setState({ ispopupshow: false , isshowsavetemplate: false});
  };

  handleChange = (e: any, control: any) => {
    //e.preventDefault();

   
    this.setState({ templatename: e.target.value });
    
  };

  
  handleChange1 = (event: any, FieldType: string) => {

    let isStateChanged = true;
    let start = 0;
    let end = 0;

    let formData = { ...this.state.formData };
if (FieldType === "DrawingRevision") {
  formData.DrawingRevision =
    event.target.value.trim().length > 0 ? event.target.value : "";
} else if (FieldType === "DrawingNo") {
  formData.DrawingNo =
    event.target.value.trim().length > 0 ? event.target.value : "";
} 
this.setState({ formData, isStateChanged, isSpinner: false }, () => {
  // let txtID = "txtInvoice";
  // let txtInvoice = $("input[id^='" + txtID + "']")[0] as any;
  // txtInvoice.selectionStart = start;
  // txtInvoice.selectionEnd = end;
});
};

  handleCloseModel = () => {
    this.setState({ ispopupshow: false , isshowsavetemplate:false});
  };
  showSaveProcessTemplatePopup = (type,isRecreated,files?:any) => {

    //if( this.state.jobdetailsdata.length > 1 )
    // {
    //   this.setState({ ispopupshow: true });
    // }
    // else 
    // if (this.state.ischanged == 1) {
    //   this.setState({ ispopupshow: true });
      
      
    // }
    // else {
      this.savejob(type,isRecreated,files);
    // }

  };


  Print = () => {

    let saveRequest: any = {};
    saveRequest.orderid = this.state.formData.orderid;
    saveRequest.partid = this.state.formData.partid;
    saveRequest.jobid = this.state.formData.jobid;

    JobServices.DownloadJobFile(saveRequest)
   
      .then(async (result: any | null) => {
        //this.HidecloseSlideOut();
        this.setState({ showAfterSaveModelPopup: false, isSpinner:false, });
        resolve();
      })
      .catch((error) => {
        reject();
      this.setState({ showAfterSaveModelPopup: false, isSpinner:false, });
      });
  };



  deleteJob = () => {
    this.setState({ isSpinner: true });
    let request = { ...this.state.requestlist };
    request.jobId = this.state.jobid;
    JobServices.DeleteJob(request)
      .then(async (result: any | null) => {
        if (result !== null) {

          this.closeSlideOut1();

          toast.success("Job has been deleted.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });



          this.setState({ isSpinner: false });

        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false });
        reject();
      });
  };

  showvendorpo=()=>{

this.setState({showVSlideout:true}); 
  };

  updateDescription = () => {
      let { processdataList } = this.state;

      let processlistItem: any = [];
      processdataList.forEach((items: any, index: any) => {     
        let item: any = {};

        item.Id = items.id ==null ?0 :items.id ;
        item.ProcessName = items.name;
        item.srno =items.srno;
        item.PDescription = items.description;
        item.Tenantid = items.tenantid;
        item.status=items.status;
        item.isFixed = items.isFixed;
        item.ledgercode=items.ledgercode;
        processlistItem.push(item);
      });
  

      PartTemplateService.Saveprocess(processlistItem);
    };
  
 

  savejob = (type,isrecreate,files?:any,isTemplateOverride = false) => {


    let request: any = {};

    if(this.state.isRecreate==true)
      {
    
        
        request.prvjobid =this.state.formData.jobid;
        this.state.formData.jobid=0;
      }   
    let processdataList =  this.state.processdataList;
    let itemdetailsdata = this.state.itemdetailsdata;
    let jobdetailsdata = this.state.jobdetailsdata;
    let updateDesc = false; 
console.log("***********",jobdetailsdata);
    if (!this.state.manualTracking) {
    if (jobdetailsdata.filter((x) => x.processName == 'Select' ||  x.processName == '' || x.processName.length == 0).length > 0) {
      this.setState({ isSpinner: false });
      toast.success("Please enter the Process.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      return;
    }
   }

    this.state.formData.itemdata = [];
    //itemdetailsdata.forEach(element => {
    let item1: any = {};
    item1.id = 0;
    let element = itemdetailsdata[0];
    item1.itemid = element.itemid;

    item1.itemname = (element.defaultitemname.length == 0 || element.defaultitemname[0].itemname === undefined) ? element.itemname : element.defaultitemname[0].itemname;
    //element.itemname;
    item1.glcode = element.glcode;
    item1.unit = element.unit;
    item1.stockqty = element.stockqty;
    item1.reqqty = element.qty;
    item1.orderqty = element.orderqty;
    item1.materialDesc = element.materialDesc;
    item1.unitprice =Utils.removeInvaildCharFromAmount(element.unitPrice);
    this.state.formData.itemdata.push(item1);

    //});
    // if (this.state.formData.itemdata.filter((x) => x.itemname == "" || x.itemname == undefined).length != 0) {

    //   toast.error("Please select item.", {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //     containerId: "OrderSlideout",
    //   });
    //   return;
    // }


if(this.state.formData.itemdata.filter((x) => x.itemname != "").length != 0)
{
    // if (this.state.formData.itemdata.filter((x) => x.unitprice == '' ).length != 0) {

    //   toast.error("Please enter valid Unit Price.", {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //     containerId: "OrderSlideout",
    //   });
    //   return;
    // }



    // if (this.state.formData.itemdata.filter((x) =>x.orderqty ==='').length != 0) {

    //   toast.error("Please enter valid order Qty.", {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //     containerId: "OrderSlideout",
    //   });
    //   return;
    // }

  }
  else
{

  this.state.formData.itemdata=[];
}


    this.state.formData.jobdetails = [];
    jobdetailsdata.forEach(element => {
      let item: any = {};
      item.id = element.id;
      item.jobid = this.state.jobid;
      item.processid = element.processid;
      item.processname = element.processName;
      item.type = element.type;
      item.jdescription = element.jDescription;
      item.assignedid = element.assignedid == null ? 0 : element.assignedid;
      item.workstationid = element.workstationid == null ? 0 : element.workstationid;
      item.tenantid = 0;
      item.processorder = element.processOrder;
      item.qty = parseInt(element.qty);
      this.state.formData.jobdetails.push(item);

      const matchingProcess = processdataList.find(process => process.id === element.processid);
      if (matchingProcess && !matchingProcess.description && element.jDescription) {
        matchingProcess.description = element.jDescription;
        updateDesc = true;
      }

    });
    
    if(this.state.formData.jobid==null)
    {

      this.state.formData.jobid=0;
    }
    this.state.formData.jobassignedId = this.state.jobassignedid;
    this.state.formData.processid = this.state.jobprocessid;
    this.state.formData.ManualTracking= this.state.manualTracking;
    


    let selectedTemplate = this.state.templatelistitem.filter(x => x.id === this.state.jobprocessid);
    let tnameselect = selectedTemplate != null && selectedTemplate.length > 0 ? this.state.templatelistitem.filter(x => x.id === this.state.jobprocessid)[0].name : '';

    this.state.formData.tname = tnameselect;
    this.state.formData.isSaveTemplate = this.state.isshowsavetemplate ? 'true' : 'false';
    this.state.formData.isOverrideTemplate = isTemplateOverride ? 'true' : 'false';
    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    this.setState({ isSpinner: true,ispopupshow:false , isshowsavetemplate:false });
    // console.log("ppppppp",request);
    // return;
    if(files){
      JobServices.SaveJobFiles(request,files)
      .then(async (result: any | null) => {
        
        if (result !== null) {
            if (result=="Template updated")
         { 
          toast.success("Template has been updated.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
            this.state.formData.templatename = "";
            this.setState({ isSpinner: false, templatename: "" });
            reject();
            return;
         }
         if (result=="Alreadytemplate")
         {
          if (isTemplateOverride) {
            toast.error("Unable to override the template. Please try again." , {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
            this.state.formData.templatename = "";
            this.setState({ isSpinner: false, templatename: "" });
            reject();
            return;
          } else {
            this.setState({ isSpinner: false });
            confirmAlert({
              title: "Confirmation",
              message: "A template with this name already exists. Do you want to override it?",
              buttons: [
                {
                  label: "Yes",
                  onClick: () => {
                    this.state.formData.templatename = this.state.templatename;
                    this.savejob(type, isrecreate, files, true);
                  },
                },
                {
                  label: "No",
                  onClick: () => {
                    this.state.formData.templatename = "";
                    this.setState({ templatename: "", isSpinner: false });
                  },
                },
              ],
              closeOnEscape: false,
              closeOnClickOutside: false,
            });
            reject();
            return;
          }
         }
         else
         {
          if(updateDesc) this.updateDescription();
          this.GetUploadFileList( result.jobid, 1);

          if(this.state.formData.isSaveTemplate === "true"){
            toast.success("Template has been created.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
            this.getProcessTemplate({});
          } else if (this.state.jobid === 0) {

            toast.success(result.jobNo + " Job has been created.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
          }
          else {

            toast.success("Job has been updated.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });

          }
          this.state.formData.jobid=result.jobid;
          this.setState({ isSpinner: false,ispopupshow:false,isStateChanged:false,ischanged:0,
            isRecreate:false,
            selectedTemplateId:0,
            selectedTemplateName:"",
            selectedJobNo:"",
            templatena:"",
            templatename:"",
            jobid:result.jobid,
            processdataList
           },()=>{
            if (type == 1) {
              this.closeSlideOut();
              //this.props.closeSlideOut(this.state?.shouldReloadMainPage);
            }
            else {
              if (this.state.jobid === 0) {
              let requestlist = { ...this.state.requestlist };
              this.setState({isRecreate:false});
              this.getjobdata();
              this.GetItemlist(requestlist);
              this.getassigntodata(requestlist);
              }
            }
           }
          
          
          );
          //this.reopenSlideOutWithNextJob();
       
        }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false });
        reject();
      });
    }else{
      JobServices.SaveJob(request)
      .then(async (result: any | null) => {
        
        if (result !== null) {
           if (result=="Template updated")
         { 
          toast.success("Template has been updated.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
            this.state.formData.templatename = "";
            this.setState({ isSpinner: false, templatename: "" });
            reject();
            return;
         }
         if (result=="Alreadytemplate")
         {
          if (isTemplateOverride) {
            toast.error("Unable to override the template. Please try again." , {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
            this.state.formData.templatename = "";
            this.setState({ isSpinner: false, templatename: "" });
            reject();
            return;
          } else {
            this.setState({ isSpinner: false });
            confirmAlert({
              title: "Confirmation",
              message: "A template with this name already exists. Do you want to override it?",
              buttons: [
                {
                  label: "Yes",
                  onClick: () => {
                    this.state.formData.templatename = this.state.templatename;
                    this.savejob(type, isrecreate, files, true);
                  },
                },
                {
                  label: "No",
                  onClick: () => {
                    this.state.formData.templatename = "";
                    this.setState({ templatename: "", isSpinner: false });
                  },
                },
              ],
              closeOnEscape: false,
              closeOnClickOutside: false,
            });
            reject();
            return;
          }
         }
         else
         {
          if(updateDesc) this.updateDescription();

          if(this.state.formData.isSaveTemplate === "true"){
            toast.success("Template has been created.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
            this.getProcessTemplate({});
          } else if (this.state.jobid === 0) {

            toast.success(result.jobNo + " Job has been created.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
          }
          else {

            toast.success("Job has been updated.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });

          }
          this.state.formData.jobid=result.jobid;
          const id = this.state.jobid;
          this.setState({ isSpinner: false,ispopupshow:false,isStateChanged:false,ischanged:0,
            isRecreate:false,
            selectedTemplateId:0,
            selectedTemplateName:"",
            selectedJobNo:"",
            templatena:"",
            templatename:"",
            jobid:result.jobid,
            processdataList
           },()=>{
            if (type == 1) {
              this.closeSlideOut();
              //this.props.closeSlideOut(this.state?.shouldReloadMainPage);
            }
            else {
                // if (id === 0) {
                let requestlist = { ...this.state.requestlist };
                this.setState({isRecreate:false});
                this.getjobdata();
                this.GetItemlist(requestlist);
                this.getassigntodata(requestlist);
                // }
                
            }
           }
          
          
          );
          //this.reopenSlideOutWithNextJob();
       
        }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false });
        reject();
      });
    }
    
  };

  recreateJob = (eventKey: any) => {
    if (eventKey == "DeleteJob") {
      // this.deleteJob();
      let masg = "";

      masg = "Are you sure you want to delete this Job?";

      confirmAlert({
        title: "Delete Job",

        message: masg,
        buttons: [
          {
            label: "Yes",
            onClick: () => this.deleteJob(),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],

        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    }
    else if (eventKey=="Print")
    {

      this.Print();
    }
   
    else {


      this.setState({isStateChanged:true,isRecreate:true,manualTracking:true,
        processVendorPOCreated:false,materialVendorPOCreated:false,trackerProcessIds:null    },()=>{
          this.state.formData.jobNo=this.state.formData.jobNo+"-RW";
          this.getjobdata();

        }
      
      );
     // this.savejob(1,1);
     // this.props.reopenSlideOutWithReworkJob();
    }
  };

  applyTemplate = () => {
    /*if(this.state.templateType=='Template')
      this.setState({ jobprocessid: this.state.selectedTemplateId, jobprocess: this.state.selectedTemplateName ,showProcessPopup: false, jobdetailsdata: this.state.processData });

    else */
      this.setState({jobprocessid: this.state.selectedTemplateId, jobprocess: this.state.selectedTemplateName ,showProcessPopup: false, jobdetailsdata: this.state.processData,isStateChanged:true});
      
     
  };
onFileChange = (event: any, mode) => {
  
      // 
      let newfiles: any = [];
      if (event.target.files.length > 0) {
        for (let i = 0; i < event.target.files.length; i++) {
          let fileRow = event.target.files[i];
          newfiles.push(fileRow);
        }
        this.onDrop(newfiles, mode);

        if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.value = null;
    }

        let fileList = document.getElementById("formControlsFile") as any;
        fileList.value = "";
      }
    };
  
    onDrop = (filelist: any, mode: any) => {
      let size = this.state.fileSize; //5242880//5MB
      let newfiles: any = [];
      let files: any = [];
      let isReturn = true;
      let filestext = "";
      let filesizeval = Number(Number(this.state.fileSize) / (1024 * 1024));
      filelist.forEach((element) => {
        if (element.size > size) {
          filestext = filestext + element.name + ",";
          isReturn = false;
        }
      });
  
      if (!isReturn) {
        let msg = "One or more files are greater than " + filesizeval + "MB.";
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
      }
      let isInvalidFile = false;
      filelist.forEach((element) => {
        if (
          (element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "pdf" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "doc" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "docx" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "xls" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "xlsx" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "csv" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "txt" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "bmp" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "tif" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "ppt" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "pptx" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "rtf" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "jpg" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "jpeg" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "png" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "msg" ||
            element.name
              .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
              .toLowerCase() === "eml") &&
          element.size <= size
        ) {
          newfiles.push(element);
          files.push(element);
        } else {
          isInvalidFile = true;
        }
      });
      if (isInvalidFile && isReturn) {
        let msg = "";
        if (filelist.length === 1) {
          msg = "This file type is not supported.";
        } else {
          msg = "Some files are not supported.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });
      }
  
      this.setState(
        {
          files,
          newSelectfiles: newfiles,
          isSave: true,
          ispopupshow: false,
          // isSpinner: true,
        },
        () => {
          if (files.length > 0) {
            this.showSaveProcessTemplatePopup(0,0,files);
          }
        }
      );
    };

    handleButtonClick = () => {
      if (this.fileInputRef.current) {
        this.fileInputRef.current.click();
      }
    };

     handleFileDelete(newfiles, file) {
        let request: any = {};
        request.fileUniqueno = file.fileUniqueno;
        request.transactionid = this.state.formData.jobid;
        request.transactiontype = "jobOrder";
    
        this.handleDeleteFileFromDb(request, newfiles, 2);
      }

       handleFileDeleteCust(newfiles, file) {
        let request: any = {};
    request.fileUniqueno = file.fileUniqueno;
    request.orderid = this.state.customerorderid;
    
        this.handleDeleteFileFromDbCust(request, newfiles, 2);
      }

       handleDeleteFileFromDbCust(request, newfiles, id) {
          let fileno = request.fileNo;
          CustomerService.DeleteUploadedFile(request)
            .then(async (result: any | null) => {
              if (result !== null) {
      
              this.setState({ isSaveSpinner: false, isDisabled: false, isStateChanged: false ,isOpenViewer:false});
              this.getjobdata();
      
              }
              resolve();
            })
            .catch((error) => {
              reject();
            });
        }


      handleDeleteFileFromDb(request, newfiles, id) {
        TransactionService.DeleteUploadedFileTransaction(request)
          .then(async (result: any | null) => {
            if (result !== null) {
    
              this.setState({ isSaveSpinner: false, isDisabled: false, isStateChanged: false ,isOpenViewer:false});
              this.getjobdata();
            }
            resolve();
          })
          .catch((error) => {
            reject();
          });
      }

 isDeleteattachmentCust(file) {
      let newfiles: any = [];
      this.state.savedfiles.forEach((element, idx) => {
        if (Number(file.fileUniqueno) !== Number(element.fileUniqueno)) {
          newfiles.push(element);
        }
      });
      this.handleFileDeleteCust(newfiles, file);
    }
  

    isDeleteattachment(file) {
      let newfiles: any = [];
      this.state.savedfiles.forEach((element, idx) => {
        if (Number(file.fileUniqueno) !== Number(element.fileUniqueno)) {
          newfiles.push(element);
        }
      });
      this.handleFileDelete(newfiles, file);
    }
  
  downloadTranactionFileCust = (file: any) => {
      CustomerService.DownloadTranactionFile(file)
        .then(async (result: any | null) => {
          resolve();
        })
        .catch((error) => {
          reject();
          this.setState({ isSaveSpinner: false });
        });
    };

   downloadTranactionFile = (file: any) => {
      TransactionService.DownloadTransactionFile(file)
        .then(async (result: any | null) => {
          resolve();
        })
        .catch((error) => {
          reject();
          this.setState({ isSaveSpinner: false });
        });
    };

     handleSelectFileUpload = (eventKey: any, file, index) => {
        if (eventKey === "delete") {
          let request: any = {};
          request = Object.assign(
            {},
            JSON.parse(JSON.stringify(this.state.formData))
          );
          let masg = "";
    
          masg = "Are you sure you want to delete this Attachment?";
    
          confirmAlert({
            title: "Delete Attachment",
    
            message: masg,
            buttons: [
              {
                label: "Yes",
                // onClick: () => this.isDeleteattachment(file),
                 onClick: () => {
            if (file.source === "jobOrder") {
              this.isDeleteattachment(file);
            } else if (file.source === "customerOrder") {
              this.isDeleteattachmentCust(file);
            } else {
              console.warn("Unknown file source:", file);
            }
          },
              },
              {
                label: "No",
                onClick: () => reject(),
              },
            ],
    
            closeOnEscape: false,
            closeOnClickOutside: false,
          });
        } else if (eventKey === "download") {
          console.log("ppppp0",file);
          if (file.source === "jobOrder") {
      this.downloadTranactionFile(file);
    } else if (file.source === "customerOrder") {
      this.downloadTranactionFileCust(file);
    } else {
      console.warn("Unknown file source:", file);
    }
        }else if(eventKey === "view"){
         this.OpenViewerSingle(index);
        }
      };

      hideBulkselect() {
        this.setState({
          bulkSelect: false,
          chkIds: [],
          selectedChk: [],
          isMapped: "No",
        });
        for (let i = 0; i < this.state.savedfiles.length; i++) {
          this["myRef" + i].current.hideBulkSelect();
        }
      }
    OpenViewer() {
      if (this.state.bulkSelect && this.state.isOpenViewer) {
        this.hideBulkselect();
      }
      this.setState(
        (prevState) => ({
          isOpenViewer: !prevState.isOpenViewer,
          singleView:false,
          fileSelect:
            this.state.savedfiles.length > 0
              ? this.state.savedfiles[0]
              : this.state.newSelectfiles[0],
          isMapped: "No",
          isExtractOption: false,
        }),
        () => {
          this.setState({ defaultView: "doc-view" });
          if (this.state.isOpenViewer) {
            setTimeout(() => {
              const innerWidthSec = this.scrollheight.current
                .getElement()
                .getBoundingClientRect().height;
              this.setState({ scrollAreaHeight: innerWidthSec });
            }, 100);
          }
        }
      );
    }

    OpenViewerSingle(index:any) {
      if (this.state.bulkSelect && this.state.isOpenViewer) {
        this.hideBulkselect();
      }
      this.setState(
        (prevState) => ({
          isOpenViewer: !prevState.isOpenViewer,
          singleView:true,
          singleViewFiles: [this.state.savedfiles[index]],
          fileSelect:
            this.state.savedfiles.length > 0
              ? this.state.savedfiles[0]
              : this.state.newSelectfiles[0],
          isMapped: "No",
          isExtractOption: false,
        }),
        () => {
          this.setState({ defaultView: "doc-view" });
          if (this.state.isOpenViewer) {
            setTimeout(() => {
              const innerWidthSec = this.scrollheight.current
                .getElement()
                .getBoundingClientRect().height;
              this.setState({ scrollAreaHeight: innerWidthSec });
            }, 100);
          }
        }
      );
    }

    setTotalPages = (totalpage) => {
      let isextractShow =
        this.state.savedfiles.length === 1 && totalpage === 1 ? true : false;
      this.setState({ isextractShow, isExtractOption: false });
    };
    handleZoom = (event) => {
      let currZoom = this.state.currentZoom;
      let updateZoom;
      if (event === "zoomIn") {
        updateZoom = currZoom * 1.5;
      } else {
        updateZoom = currZoom / 1.5;
      }
      // console.log("updateZoom-" + updateZoom);
      this.setState({ currentZoom: updateZoom });
    };
  
    handleAllCheckbox(event) {
      for (let i = 0; i < this.state.savedfiles.length; i++) {
        this["myRef" + i].current.handleAllCheckbox(event);
      }
    }


   moreActions = (eventKey: string) => {
  let { jobdetailsdata, manualTracking,isAssignment ,isQty} = this.state;

  if (eventKey === "assignment") {
    const updatedData = jobdetailsdata.map((item: any) => ({
      ...item,
      workstationid: 0,
      assignedid: 0,
      assignedName:"",
    }));

    
    this.setState({ jobdetailsdata: updatedData , isAssignment: !isAssignment, });

  } else if (eventKey === "qty") {
    const updatedData = jobdetailsdata.map((item: any) => ({
      ...item,
      qty: 0,
    }));
    this.setState({ jobdetailsdata: updatedData ,isQty: !isQty});

  } else if (eventKey === "tracking") {
     const newTrackingState = !this.state.manualTracking;
 let updatedJobDetails = [...jobdetailsdata];
    let newIsAssignment = isAssignment;
    let newIsQty = isQty;

    if (!newTrackingState) {
      if (!isAssignment) {
        updatedJobDetails = updatedJobDetails.map((item: any) => ({
          ...item,
          workstationid: 0,
          assignedid: 0,
          assignedName: "",
        }));
        newIsAssignment = true;
      }
      if (!isQty) {
        updatedJobDetails = updatedJobDetails.map((item: any) => ({
          ...item,
          qty: 0,
        }));
        newIsQty = true;
      }
    }
  this.setState(
    { manualTracking: newTrackingState, 
        jobdetailsdata: [],
        isAssignment: newIsAssignment,
        isQty: newIsQty,
        isStateChanged: true },
    () => {
      this.setState({jobdetailsdata: updatedJobDetails});
          toast.success(`Tracking has been ${newTrackingState ? "disabled" : "enabled"} successfully!`, {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });
    }
  );

  }else if(eventKey === "confirmReset"){
   const defaultElement = {
      processList: [],
      processName: "Select",
      processid: 0,
      tdescription: "",
      jDescription: "",
      processOrder: 0,
      qty: 0,
       workstationid: 0,
      assignedid: 0,
      assignedName:"",
    };
    this.setState({ jobdetailsdata: [defaultElement] ,unsave: false  });
  } else {
    this.setState({unsave: true  });
  }
};


  render() {
    const { permissions } = this.props; 
    const hasEditJobPermission = permissions && permissions['Job Order'] ? permissions['Job Order'].includes('Assign Job') : false;
    const hasAddJobPermission = permissions && permissions['Job Order'] ? permissions['Job Order'].includes('Save Job') : false;
    const hasAddTrackPermission = permissions && permissions['Tracker'] ? permissions['Tracker'].includes('Track') : false;

    const {
showSlideout,
showVSlideout,
showOrderSlideout,
showPartSlideout
    } = this.state;
    const rowClasses = 'custom-row-class';
     const options = {
    
    
  
    sizePerPage: 8,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true
  
  
  // A numeric array is also available. the purpose of above example is custom the text
    };

// alert(this.state.jobid);
// alert(this.state.jobTrackerId);
// alert(this.state.processVendorPOCreated);
//alert(this.state.materialVendorPOCreated);


 const templateColumns = [

    {
      dataField: 'srno',
      text: 'Step',
      headerStyle: { width: '50px' },
      formatter: (cell: any, row: any, rowIndex: any) => {

        return (
          <div>
            {rowIndex + 1}
          </div>
        );
      },
    },
    {
      dataField: "isSelected",
      text: "",
      classes: "expanding-bar",
      headerStyle: { width: '10px' },
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          <div className="d-flex align-items-center txt-bold">

            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="toolp">Click to move up this step</Tooltip>
              }
            >
              <FontAwesomeIcon
                icon={faArrowUp}
                size="xs"
                onClick={(e) => this.handleRowOrdering(e, row, 'up')}
                className='cursor-pointer'
              />
            </OverlayTrigger>
          </div>
        );
      },
    },

    {
      dataField: "isSelected",
      text: "",
      classes: "expanding-bar",
      headerStyle: { width: '10px' },
      formatter: (cell: any, row: any, rowIndex: any) => {
        return (
          <div className="d-flex align-items-center txt-bold">

            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="toolp">Click to move down this step</Tooltip>
              }
            >
              <FontAwesomeIcon
                icon={faArrowDown}
                size="xs"
                onClick={(e) => this.handleRowOrdering(e, row, 'down')}
                className='cursor-pointer'
              />
            </OverlayTrigger>
          </div>
        );
      },
    },

    {
      dataField: 'type',
      text: 'Type',
      headerStyle: { width: '150px' },
      hidden: true,
      editable: false,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txttype" + rowIndex + "txt";
        let disable = true;
        return (
          <div>
            <Form.Control tabIndex={this.state.tabEnable}
              id={id}
              type="text" placeholder="Enter Type" value={row.type}
              onChange={(e) => this.updateState(e, rowIndex, "type", id)}
              autoComplete='off'
              disabled={disable}
              title=""
              maxLength={500}
            />
          </div>

        );



      },
    },
   
    
    {
      dataField: 'processName',
      text: 'Process',
      headerStyle: { width: '200px' },
      //headerFormatter: this.iconFormatter,
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtprocess" + rowIndex + "txt";
        let disable = this.state.trackerProcessIds != null && this.state.trackerProcessIds.filter((x) => x == row.id).length > 0 ? row.manualTracking==true? false :  true : false;
        // this.state.trackerProcessIds != null && this.state.trackerProcessIds.filter((x)=>x == row.processid).length > 0;
        return (
          <div style={{ opacity: disable ? 0.5 : 1, pointerEvents: disable ? 'none' : 'auto' }}>
            {/* <Form.Control tabIndex={this.state.tabEnable}
                        id={id}
                        type="text" placeholder="Enter Process" value={row.process}
                       // onChange={(e) => this.updateState(e, rowIndex, "partNo", id)}
                        autoComplete='off'
                        disabled={disable}
                        title=""
                        maxLength={500}
                    /> */}
            <JobSearch
              tabIndex={this.state.tabEnable}
              itemList={this.state.processdataList}
              handleSelectedItem={this.handleSelectedItem.bind(row, 2 + '_' + rowIndex)}
              defaultItem={row.processName}
              defaultText={"Search Process"}
              defaultName={row.processName}
              getjobdata={this.getRefreshjobdata}
              controlID="1"
              id={"ddlprocess-" + rowIndex + "ddl"}
            //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}

            />
          </div>
        );



      },

    },
      {
        dataField: 'jDescription',
        text: 'Description',
        headerStyle: { width: '600px' },
        hidden: false,
        editable: false,
        headerAttrs: (column, colIndex) => (
          { 'tabIndex': '-1' }
        ),
        formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtdescription" + rowIndex + "txt";
          const firstLinedescription = row.jDescription ? row.jDescription.split('\n')[0] : ''; 
          let disable = false;
          return (
            <div style={{ position: 'relative' }}>
              <Form.Control tabIndex={this.state.tabEnable}
                id={id}
                type="text" placeholder="Enter Description" 
                value={firstLinedescription}
                onChange={(e) => this.updateState(e, rowIndex, "description", id)}
                autoComplete='off'
                disabled={disable}
                style={{ paddingRight: '30px' }} 
                title=""
                maxLength={500}
              />
              <FaPencilAlt 
              
              onClick={() => this.handleEditClick(rowIndex, row.jDescription)} 
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
              }} 
            />
  
            </div>

          );



        },

      },
 {
          dataField: 'assignedId',
          text: 'Assigned To',
          headerStyle: { width: '400px' },
          hidden: !this.state.isAssignment,
          editable: false,
          headerAttrs: (column, colIndex) => (
            { 'tabIndex': '-1' }
          ),
          formatter: (cell: any, row: any, rowIndex: any) => {
            let id = "txtprocessby" + rowIndex + "txt";
            let disable = row.status =="completed" ?true : false;
            
            return (
              <div>
              
               <SingleSearchDropdownListBootrap
                  tabIndex={this.state.tabEnable}
                  itemList={this.state.TypeUserlist}
                  handleSelectedItem={this.handleSelectedItem.bind(row, 6 + '_' + rowIndex)}
                  defaultItem={row.assignedId > 0 ? 'u:'+ row.assignedId :(row.workstationId > 0 ? 'w:'+ row.workstationId:"Unassigned")}
                  defaultText="Select Process By"
                  //defaultName={row.processby}
                  controlID="1"
                  defaultName={row.assignedName}
                  id={"ddlprocess-" + rowIndex + "ddl"}
                  //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}
                  isdisable={disable} 
                />
                
              </div>
            
    
            );
    
    
    
          },
    
        },
 {
      dataField: "qty",
      text: "Qty Completed",
      headerClasses: "coa",
      hidden:!this.state.isQty,
      headerStyle: { width: "10px" },
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
          let id = "txtCompletedQty" + rowIndex + "txt";
           const isManual = this.state.manualTracking === false;
    const valueToShow = isManual ? (row.trackQty || 0) : row.qty;
    const isDisabled = isManual ? true : false;
          return (
              <Form.Control
            tabIndex={this.state.tabEnable}
            id={id}
            type="text"
             placeholder="Enter qty"
            value={valueToShow}
            onChange={(e) => this.updateState(e, rowIndex, "qty", id)}
            autoComplete="off"
            //pattern="[+-]?\d+(?:[.,]\d+)?"
            maxLength={200}
             disabled={isDisabled}
            title=""
          />
            
          );
        },
    },
      {
                     dataField: "manualTracking",
                     text: "Tracking",
                     headerClasses: "coa text-center",
                     hidden: this.state.manualTracking,
                     classes:'text-center',
                     headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
                     formatter: (cell: any, row: any, rowIndex: any) => {
                          const isDisabled = !this.state.formData.jobid;
                          let badgeColor = "color-green"; 
                            if (row.status) {
                              switch (row.status.toLowerCase()) {
                                case "completed":
                                  badgeColor = "color-green";
                                  break;
                                case "hold":
                                  badgeColor = "color-red"; 
                                  break;
                                case "progress":
                                  badgeColor = "color-yellow"; 
                                  break;
                                case "inactive":
                                  badgeColor = "badge-grey"; 
                                  break;
                                default:
                                  badgeColor = "badge-success";
                              }
                            }
                       return (                        
                            <div
                              className={`cursor-pointer ${(isDisabled || !row.status ) ? "disabled-tracking" : ""}`}
                              onClick={() => !isDisabled && row.status && this.openSlideout()}
                            >

                              
                               {!isDisabled && row.status ? (
                              <span className={`badge badge-pill badge-primary  ${badgeColor} ml-1`}>
                                {row.status}
                              </span>
                            ):(<>
                    <FontAwesomeIcon icon={faStopwatch } /></>
                            )}
                                              </div>
                       );
                     },
                      headerFormatter: (column: any, colIndex: any) => {
                    const isDisabled = !this.state.formData.jobid;

                    return (
                      <div
                        className={`cursor-pointer`}
                        onClick={() =>
                          !isDisabled && this.openSlideout()
                        }
                      >
                        {column.text}
                      </div>
                    );}
                   },
    {
      dataField: 'Attachment',
      text: 'Delete',
      //headerFormatter: this.iconFormatter,
      headerAttrs: (column, colIndex) => (
        { 'tabIndex': '-1' }
      ),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let confirmModalContent = [
          {
            title: "Delete Row",
            desc: "Are you sure you want to delete?",
            cancleAction: "Cancel",
            ActionTrue: "Delete",
          },
        ];

        if (this.state.jobdetailsdata.length === 1 || (this.state.trackerProcessIds != null && this.state.trackerProcessIds.filter((x) => x == row.id).length > 0)) {
          return (
            <div></div>
          );
        }


        else {
          return (
            <Dropdown className="more-action confirmation-modal"  tabIndex={this.state.tabDisable}>
              <Dropdown.Toggle className="btn-outline-primary btn btn-primary more fa-trash" id="dropdown-more-delete" tabIndex={this.state.tabDisable}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 5.83329C4.53917 5.83329 4.16667 5.83329 4.16667 5.83329V16.6666C4.16667 17.5866 4.91333 18.3333 5.83333 18.3333H14.1667C15.0867 18.3333 15.8333 17.5866 15.8333 16.6666V5.83329C15.8333 5.83329 15.4608 5.83329 15 5.83329H5ZM8.33333 15.8333H6.66667V8.33329H8.33333V15.8333ZM13.3333 15.8333H11.6667V8.33329H13.3333V15.8333ZM13.8483 3.33329L12.5 1.66663H7.5L6.15167 3.33329H2.5V4.99996H6.66667H13.3333H17.5V3.33329H13.8483Z" />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ConfirmationModal
                  confirmModalContent={confirmModalContent}
                  ishandleDeletePosition={this.ishandleDeleteRow.bind(
                    this,
                    row
                  )}
                />
              </Dropdown.Menu>
            </Dropdown>
          );
        }
      },
    },

  ];



    const cardContainerStyles = "p-1 max-w-sm mx-auto bg-white rounded-lg border border-zinc-200 shadow-md dark:bg-zinc-800 dark:border-zinc-700 rounded";
    const titleStyles = "font-semibold text-sm text-zinc-900 dark:text-white";
    const subTitleStyles = "text-zinc-500 dark:text-zinc-400";
    const subTitleStyles2 = "text-zinc-300 dark:text-zinc-200";
   
    const files1 = this.state.savedfiles.map((file, index) => (
                  <>
                    <div>
                      <li key={file.name}>
                        <div className="d-flex align-items-center justify-content-start">
            
                          <div className="file-info d-flex align-items-center">
                            <div className="name-loader d-flex align-items-center">
                              <div className="name">
                                {/* <EllipsisWithTooltip placement="bottom"> */}
                                  {/* <div className="full-name" style={{ fontSize: '14px', marginRight: '70px' }}>{file.name}</div> */}
                                  <div className="full-name" style={{ fontSize: '14px',textAlign:'left'}}>{file.name}</div>
                                {/* </EllipsisWithTooltip> */}
                              </div>
                            </div>
                          </div>
                          <div className="action">
                            {
                              <Dropdown
                                className="more-action"
                                
                                onSelect={(event: any) =>
                                  this.handleSelectFileUpload(event, file, index)
                                }
                              >
                                <Dropdown.Toggle
                                  className="btn-outline-primary btn btn-primary more border-0"
                                  id="dropdown-more"
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                                  </svg>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {this.state.moreActionFileUpload1.map(
                                    (item: any, idx: any) => (
                                      <>
                                        {this.state.formData.jobid === 0 && (
                                          <Dropdown.Item
                                            //  className={( this.state.moreActionFileUpload1[idx].eventKey === "delete") ? "isHide" : ""}
                                            //className={((this.state.formData.actionType === "copy" || this.state.isError === "NotEdit") && this.state.formData.uniqueno > 0) ? "isHide" : ""}
                                            eventKey={
                                              this.state.moreActionFileUpload1[idx].eventKey
                                            }
                                            key={idx}
                                          >
                                            {this.state.moreActionFileUpload1[idx].name}
                                          </Dropdown.Item>
                                        )}
            
                                        {this.state.formData.jobid > 0 && (
                                          <Dropdown.Item
                                            // className={(    this.state.moreActionFileUpload1[idx].eventKey === "delete") ? "isHide" : ""}
                                            eventKey={
                                              this.state.moreActionFileUpload1[idx].eventKey
                                            }
                                            key={idx}
                                          >
                                            {this.state.moreActionFileUpload1[idx].name}
                                          </Dropdown.Item>
                                        )}
                                      </>
                                    )
                                  )}
                                </Dropdown.Menu>
                              </Dropdown>
                            }
                          </div>
                        </div>
                      </li>
                    </div>
                  </>
                ));
                const savedfilesCount = this.state.savedfiles.length;
                const allsavedfiles = this.state.savedfiles;
                const currentView = this.state.defaultView;
        
                const handleUpdate = (newtext) => {
                  //this.setState({ defaultView: "doc-view"});
                  toggleSwitch("doc-view");
                  setTimeout(function () {
                    var currentPos: any = $(`#${newtext}`).offset()?.top;
                    var marginArea = currentPos - 138;
                    $(".scroll-area").animate(
                      {
                        scrollTop: marginArea,
                      },
                      500
                    );
                  }, 500);
                };
            
                const handleUpdateFiles = (docFiles) => {
                  //let docViewerFiles : any =[];
                  docViewerFiles.push(docFiles);
                  //this.setState({ docViewerFiles: docFiles })
                };
            
                const showBulkSelect = (type) => {
                  this.setState({ bulkSelect: type === "show" ? true : false });
                  for (let i = 0; i < this.state.savedfiles.length; i++) {
                    this["myRef" + i].current.showBulkSelect();
                  }
                };
            
                const checkBulkSelect = (type, totalpage) => {
                  // selectedPage =totalpage;
                  if (totalpage === 0) {
                    this.footerchk.current.labels[0].innerHTML = "No Page Selected";
                  } else if (totalpage === 1) {
                    this.footerchk.current.labels[0].innerHTML =
                      totalpage + " Page Selected";
                  } else {
                    this.footerchk.current.labels[0].innerHTML =
                      totalpage + " Pages Selected";
                  }
                  if (type === "removeAll") {
                    this.footerchk.current.indeterminate = false;
                    this.footerchk.current.checked = false;
                  } else {
                    if (type === "helf") {
                      this.footerchk.current.indeterminate = true;
                    } else {
                      this.footerchk.current.indeterminate = false;
                      this.footerchk.current.checked = true;
                    }
                  }
                };
        
                const toggleSwitch = (event: any) => {
                  this.setState({ defaultView: event });
                  $(".scroll-area").animate(
                    {
                      scrollTop: 0,
                    },
                    500
                  );
                };

    return (

      <section>
        <div
         className="details-drawer"
          style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
        // className="back-drop1  viewer-panel1 opacity "
        >
          <ToastContainer
            containerId={"userDetailSlideoutcontainer"}
            autoClose={3000}
          />
           {!this.state.isOpenViewer && (
            <div
              className="back-drop1  viewer-panel1 opacity"
              // onClick={() => this.closeSlideOut()}
            ></div>
          )}


{this.state.isOpenViewer && (
                                                <div
                                                  // className="back-drop viewer-panel-left bg-secondary bg-gradient z-3 position-absolute"
                                                  // //className="body-sec viewer-panel back-drop p-0 z-3"
                                                  // style={{ minWidth: "45%", width: "300px", maxWidth: "100%" }}

                                                   className="back-drop viewer-panel bg-white z-3 position-absolute"
                                                   style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
                                    
                                                >
                                                  <div
                                                    className="scroll"
                                                  >
                                                    <div className="header-panel d-flex justify-content-between align-items-center">
                                                      <div className="page-ttl">Attachments</div>
                                                      {/* <div className="toggle-button">
                                                        <ButtonGroup aria-label="Basic example">
                                                          <ToggleButtonGroup
                                                            type="radio"
                                                            name="options"
                                                            value={this.state.defaultView}
                                                            onChange={toggleSwitch}
                                                          >
                                                            <ToggleButton value={"doc-view"} id={"t1"}>
                                                              <svg
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                              >
                                                                <path d="M10.155 12.1267C9.64082 12.1267 9.34082 12.6159 9.34082 13.2709C9.34082 13.93 9.64999 14.3959 10.16 14.3959C10.6742 14.3959 10.9692 13.9059 10.9692 13.2509C10.9692 12.6459 10.6792 12.1267 10.155 12.1267Z" />
                                                                <path d="M11.6666 1.66663H4.99992C4.55789 1.66663 4.13397 1.84222 3.82141 2.15478C3.50885 2.46734 3.33325 2.89127 3.33325 3.33329V16.6666C3.33325 17.1087 3.50885 17.5326 3.82141 17.8451C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8451C16.491 17.5326 16.6666 17.1087 16.6666 16.6666V6.66663L11.6666 1.66663ZM11.6666 7.49996H10.8333V3.33329L14.9999 7.49996H11.6666Z" />
                                                              </svg>
                                                            </ToggleButton>
                                                            <ToggleButton value={"grid-view"} id={""}>
                                                              <svg
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 20 20"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                              >
                                                                <path d="M3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667ZM11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667ZM3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5ZM11.6667 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V11.6667C17.5 11.4457 17.4122 11.2337 17.2559 11.0774C17.0996 10.9211 16.8877 10.8333 16.6667 10.8333H11.6667C11.4457 10.8333 11.2337 10.9211 11.0774 11.0774C10.9211 11.2337 10.8333 11.4457 10.8333 11.6667V16.6667C10.8333 16.8877 10.9211 17.0996 11.0774 17.2559C11.2337 17.4122 11.4457 17.5 11.6667 17.5Z" />
                                                              </svg>
                                                            </ToggleButton>
                                                          </ToggleButtonGroup>
                                                        </ButtonGroup>
                                                      </div> */}
                                                      <div className="action d-flex">
                                                        <button
                                                          type="button"
                                                          className="btn wht-bg cross"
                                                          style={{backgroundColor:'#164DA0'}}
                                                          onClick={this.OpenViewer}
                                                        >
                                                          <svg
                                                            width="12"
                                                            height="12"
                                                            viewBox="0 0 12 12"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                          >
                                                            <path
                                                              d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                                                              fill="white"
                                                            />
                                                          </svg>
                                                        </button>
                                                      </div>
                                                    </div>
                                    
                                                    <ScrollContainer
                                                      className="doc-view scroll-area1"
                                                      // className={`scroll-area ${this.state.modalOpen === "yes" ? "modal-open" : ""
                                                      //   } ${currentView !== "doc-view" ? "grid-sec" : "doc-sec"}`}
                                    
                                    
                                                      ref={this.scrollheight}
                                                      hideScrollbars={false}
                                                    >
                                                      <>
                                                        {(this.state.singleView ? this.state.singleViewFiles : this.state.savedfiles).map((file: any, i: any) => {
                                                          return (
                                                            <div
                                                              id={`sec_${file.id}`}
                                                              className={this.state.bulkSelect ? "footer-enable" : ""}
                                                            >
                                                              <div
                                                                className={
                                                                  currentView !== "doc-view" ? "grid-sec" : "doc-sec"
                                                                }
                                                              >
                                                                <PDFViewer
                                                                  //ref={childViewerref}
                                                                  ref={this["myRef" + i]}
                                                                  scrollAreaHeight={this.state.scrollAreaHeight}
                                                                  isModalOpen={this["isModalOpen"]}
                                                                  uniqueno={this.state.orderID}
                                                                  filePreview={file.fileCode}
                                                                  defaultView={currentView}
                                                                  fileNo={file.fileUniqueno}
                                                                  fileCount={savedfilesCount}
                                                                  fileName={file.name}
                                                                  // docFile={docViewerFiles}
                                                                  docFile={allsavedfiles}
                                                                  updateState={handleUpdate}
                                                                  updateFiles={handleUpdateFiles}
                                                                  showBulkSelect={showBulkSelect}
                                                                  checkBulkSelect={checkBulkSelect}
                                                                  handleFileCheckBox={this["handleFileCheckBox"]}
                                                                  handleUpdatedFile={this["handleUpdatedFile"]}
                                                                  handleincompleteFile={this["handleincompleteFile"]}
                                                                  saveSplitFile={this["saveSplitFile"]}
                                                                  pageType={this.props.pageType}
                                                                  handleRotate={this["handleRotate"]}
                                                                  handlePageRemove={this["handlePageRemove"]}
                                                                  selectedChk={this.state.selectedChk}
                                                                  selectedZoom={this.state.currentZoom}
                                                                  setTotalPages={this["setTotalPages"]}
                                                                  isEditPermission={true}
                                                                />
                                                              </div>
                                                            </div>
                                                          );
                                                        })}
                                    
                                                        {currentView === "doc-view" && (
                                                          <div className="zoom-btn">
                                                            <ButtonGroup vertical>
                                                              <Button
                                                                onClick={(e) => this.handleZoom("zoomIn")}
                                                                disabled={
                                                                  this.state.currentZoom >= 3.375 ? true : false
                                                                }
                                                              >
                                                                <FontAwesomeIcon icon={faPlus} />
                                                              </Button>
                                                              <Button
                                                                onClick={(e) => this.handleZoom("zoomOut")}
                                                                disabled={
                                                                  this.state.currentZoom <= 0.44 ? true : false
                                                                }
                                                              >
                                                                <FontAwesomeIcon icon={faMinus} />
                                                              </Button>
                                                            </ButtonGroup>
                                                          </div>
                                                        )}
                                                        {this.state.bulkSelect && (
                                                          <div className="footer-section d-flex align-items-center ">
                                                            <Form.Check
                                                              
                                                              type="checkbox"
                                                              key={"custom-footer"}
                                                              id={"custom-footer"}
                                                              label={"No Page Selected"}
                                                              onChange={(e: any) => this.handleAllCheckbox(e)}
                                                              ref={this.footerchk}
                                                            />
                                                          </div>
                                                        )}
                                                      </>
                                                    </ScrollContainer>
                                                  </div>
                                                </div>
                                              )}
          <Container
            fluid

            className="body-sec viewer-panel back-drop p-0 "
            style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}

          >



{/* 
            <Container
              className="body-sec viewer-panel back-drop p-0 "
              style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}



            > */}

             <div
                className="scroll1"
              >

              <div
                className="container-fluid py-1 bg-white d-flex align-items-center border-bottom round-4 sticky-header"



              >
                <div className="divheader">
                  <h5 className="my-title">

                    {this.state.jobid == 0 && this.state.poNumber!=undefined && <span>New Job No: {"JO#"+this.state.poNumber}-{this.state.itemNo}{this.props.rNo}  </span>

                    }
                    {this.state.jobid != 0 && (
                       
                                    
                <div className="jobno-wrapper">
  {this.state.jobMaster.length !== 0 && <Form.Label className="jobno-label mt-1">Job No:</Form.Label>}

  {this.state.jobMaster.length === 1 && (
    <span className="badge badge-pill badge-primary color-green jobno-badge">
      {this.state.formData.jobNo}
    </span>
  )}

  {this.state.jobMaster.length > 1 && (
    <div className="jobno-dropdown">
      <SingleDropdownListWithoutSearch
        tabIndex={this.state.tabEnable}
        itemList={this.state.jobMaster}
        handleSelectedItem={this.handleSelectedItem1.bind(this, 'JobNoList')}
        defaultItem={this.state.jobid}
        defaultText={"Select job"}
        defaultName={this.state.jobNo}
        controlID="1"
        id={"ddlJob"}
        key="id"
      />
    </div>
  )}
               </div>
                       
//                        <section className="pb-2">
//     <div className="row g-2">
//                         <div className="col-md-6" >
//                         <span> 
//                         {this.state.jobMaster.length!=0  && <Form.Label>Job No :</Form.Label>
//   }
//                         </span> 
// </div>

//                     <div className="col-md-4" >
//                        <div className="w-auto">
//                       <Form.Label>
// {this.state.jobMaster.length==1  &&<span className="badge badge-pill badge-primary color-green">{ this.state.formData.jobNo}</span> }

//                                                   {this.state.jobMaster.length > 1 &&
//                         <SingleDropdownListWithoutSearch
//                     tabIndex={this.state.tabEnable}
//                     itemList={this.state.jobMaster}
//                     handleSelectedItem={this.handleSelectedItem1.bind(this, 'JobNoList')}
//                     defaultItem={this.state.jobid}
//                     defaultText={"Select job"}
//                     defaultName={this.state.jobNo}
//                     controlID="1"
//                     id={"ddlJob"}
//                     key="id"
//                   //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}
//                  // disabled={dis }
//                   />
//                                                   }




//                   </Form.Label>
//                   </div>
//                   </div>
//                        </div>
//                     </section>
                    )}
                  </h5>
                  {(this.state.trackerStatus.toLowerCase() === 'rework job' && (this.state.reworkCount == 0 || this.state.reworkCount == null) && this.props.reopenSlideOutWithReworkJob !== undefined) &&
                    (<>
                    {/* <div style={{ paddingLeft: '50px', display: 'flex' }}> */}
                      {/* NCR Raised with Rework */}
                      <span className="badge badge-pill badge-primary color-red m-2"> NCR Raised </span>


                    {/* </div> */}
                    </>)}

                  {/* {this.state.jobMaster.length > 1 && <SingleDropdownListWithoutSearch
                    tabIndex={this.state.tabEnable}
                    itemList={this.state.jobMaster}
                    handleSelectedItem={this.handleSelectedItem1.bind(this, 'JobNoList')}
                    defaultItem={this.state.jobid}
                    defaultText={"Select job"}
                    defaultName={this.state.formData.jobNo}
                    controlID="1"
                    id={"ddlJob"}
                    key="id"
                  //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}
                  // disabled={disable}
                  />} */}

                  {this.state.runningInTracker ?
                    // <Button style={{position:"fixed",right:"100px"}}>Running</Button>:""
                    <span className="badge badge-pill badge-primary color-green m-2"> Running </span>
                    : ""

                  }

                  <div className="header-popout ml-auto">

                  <div className="container text-center">
  <div className="row align-items-start">
    <div className="col">

  { this.state.jobid !=0 &&  
                            
    <div className="action">
                   
                     <Dropdown
                       className="more-action"
                       
                       onSelect={(event: any) => { this.recreateJob(event); }}
                     >
                       <Dropdown.Toggle
                         className="btn-outline-primary btn btn-primary more"
                         id="dropdown-more"
                       >
                         <svg
                           width="20"
                           height="20"
                           viewBox="0 0 20 20"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                         >
                           <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                           <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                           <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                         </svg>
                       </Dropdown.Toggle>
                       <Dropdown.Menu>
                    
                       <Dropdown.Item
                             // className={(    this.state.moreActionFileUpload1[idx].eventKey === "delete") ? "isHide" : ""}
                             eventKey={"Print"}
                             key={1}
                           >
                             {"Print"}
                           </Dropdown.Item>

{(this.state.jobid !=0 && hasEditJobPermission &&
((!this.state.materialVendorPOCreated && !this.state.processVendorPOCreated) || this.state.runningInTracker==null)
&&
<Dropdown.Item
// className={(    this.state.moreActionFileUpload1[idx].eventKey === "delete") ? "isHide" : ""}
eventKey={"DeleteJob"}
key={1}
>
{"Delete Job"}
</Dropdown.Item>
)
}

                         
                        
                         {(this.state.trackerStatus.toLowerCase() === 'rework job' && (this.state.reworkCount == 0 || this.state.reworkCount == null) && this.props.reopenSlideOutWithReworkJob !== undefined) &&
                           <Dropdown.Item
                             // className={(    this.state.moreActionFileUpload1[idx].eventKey === "delete") ? "isHide" : ""}
                             eventKey={">Re-create Job"}
                             key={1}
                           >
                             {"Re-create Job"}
                           </Dropdown.Item>
                         }
                       </Dropdown.Menu>
                     </Dropdown>

                  
                  
                 </div>
               
                     
               }
    </div>
    <div className="col">
    <button
                          type="button"
                          className="btn btn-primary cross"
                          onClick={this.closeSlideOut1}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                              fill="#ffffff"
                            />
                          </svg>
                        </button>
                      
    </div>
   
  </div>
  </div>

                  
                 
                  </div>
                </div>
                </div>
                


                <div  className="p-3">




                      <div className="row">


                        <div className="col-sm-6">
                          <div className="card h-100">
                            <div className="card-header">
                              Order Details
                            </div>
                            <div className="card-body">
                            <div className="row g-2">
                            <div className="col-md-4" >
                            Order No 
                               </div>
                            <div className="col-md-8" >
                               <span 
                                             className="cursor-pointer" 
                                             onClick={(e) => {
                                               this.setState({showOrderSlideout:true});
                                             }}
                                             style={{ textDecoration: 'underline', padding: 0, border: 'none', background: 'none', color: '#164da0' }}
                                           >
                                              {this.state.CustomerPoNumber}
                                           </span>
                           
                              </div>
                            

                              <div className="col-md-4" >
                            Order Date 
                               </div>
                            <div className="col-md-8" >
                            {this.state.jobid !=0 ?  
                                this.state.orderdate == undefined ? '' :moment(this.state.orderdate).format("MM/DD/YYYY") 
                                : this.props.orderdate == undefined ? '': moment(this.props.orderdate).format("MM/DD/YYYY")}
                              
                              </div>


                              
                              <div className="col-md-4" >
                            Customer Name 
                               </div>
                            <div className="col-md-8" >
                            {this.state.jobid !=0 ? this.state.selectedCustomer : this.props.selectedCustomer}
                              
                              </div>

                              <div className="col-md-4" >
                            Created By 
                               </div>
                            <div className="col-md-4" >
                              {this.state.assignedto}
                              {/* {this.state.assignedto !== '' && <SingleDropdownListWithoutSearch
                                tabIndex={this.state.tabEnable}
                                itemList={this.state.assigneddatatoList}
                                handleSelectedItem={this.handleSelectedItem1.bind(this, 2)}
                                defaultItem={this.state.jobassignedid}
                                defaultText={"Select Employee"}
                                defaultName={this.state.assignedto}
                                controlID="1"
                                key="assignedto"
                                id={"ddlassignddl"}
                              />} */}
                              </div>

                              
                              </div>



                            
                          

                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="card h-100">
                            <div className="card-header">
                              Part Details
                            </div>
                            <div className="card-body">
                            <div className="row g-2">
                            <div className="col-md-4" >
                            Part No 
                               </div>
                            <div className="col-md-8" >
                          
                            <span 
                                             className="cursor-pointer" 
                                             onClick={(e) => {
                                               this.setState({showPartSlideout:true});
                                             }}
                                             style={{ textDecoration: 'underline', padding: 0, border: 'none', background: 'none', color: '#164da0' }}
                                           >
                                               {this.state.orderData[0].partNo == undefined ? this.state.partNo : this.state.orderData[0].partNo} 
                                           </span>
                          
                              </div>
                              <div className="col-md-4" >
                              Part Description 
                               </div>
                              <div className="col-md-8 text-truncate" >
                              <EllipsisWithTooltip placement="bottom">
                             {this.state.orderData[0].partname == undefined ? this.state.partname : this.state.orderData[0].partname} 
                               </EllipsisWithTooltip>
                              </div>
                                <div className="col-md-4" >
                                Order QTY 
                                </div>
                                <div className="col-md-8" >
                            {this.state.qtyOrdered}
                                </div>
                                <div className="col-md-4" >
                                Due Date 
                                </div>
                                <div className="col-md-8" >
                                {this.state.jobid !=0 ?  
                                  this.state.dueDate == undefined ? '' :moment(this.state.dueDate).format("MM/DD/YYYY") 
                                  : this.props.dueDate == undefined ? '': moment(this.props.dueDate).format("MM/DD/YYYY")}
                                {/* {moment(this.state.orderData[0].dueDate).format("MM/DD/YYYY")} */}
                              
                                </div>
                                <div className="col-md-4" >
                                Drawing No. 
                                </div>
                                <div className="col-md-8" >
                                <Form.Control
                                tabIndex={this.state.tabEnable}
                                id="txtDrawingNo"
                                type="text"
                                placeholder="Enter Drawing No."
                                value={this.state.formData.DrawingNo}
                                onChange={(event: any) => this.handleChange1(event, 'DrawingNo')}
                                autoComplete="off"
                                className="w-100"
                                disabled={this.state.formData.CustomerID > 0 ? true : false}
                                title=""
                              />
                                </div>
                                <div className="col-md-4" >
                                Drawing Revision 
                                </div>
                                <div className="col-md-8" >
                                <Form.Control
                                tabIndex={this.state.tabEnable}
                                id="txtQuotationNo"
                                type="text"
                                placeholder="Enter Drawing Revision"
                                value={this.state.formData.DrawingRevision}
                                onChange={(event: any) => this.handleChange1(event, 'DrawingRevision')}
                                autoComplete="off"
                                className="w-100"
                                disabled={this.state.formData.CustomerID > 0 ? true : false}
                                title=""
                              />
                                </div>
                              </div>
                            
                            

              




                             
                              
                                
                            


                            </div>
                          </div>
                        </div>



                      </div>
                 
                
                  <section className="pt-3 pb-3">
 
          
                    <div
                      id="order"
                      className="table-responsive1 pt-2"
                    >
 <div className="card h-100">

                            <div className="card-header">
                            <Form.Label className="font-semibold">
                      Material Details  {(this.state.vendorPoNo!=null && this.state.vendorPoNo!="")  && (  <a   onClick={() => this.showvendorpo()} className="orderLinks" >
                        <span className="badge badge-pill badge-primary color-green"> Vendor  {this.state.vendorPoNo}  </span>
                        </a>
                      )}

                      {(this.state.vendorPoNo!=null && this.state.vendorPoNo!="")  && ( <span className={this.state.Received=="" || this.state.Received==null ? "badge badge-pill badge-primary color-red" :  this.state.Received=="Partial" ? "badge badge-pill badge-primary color-orange": "badge badge-pill badge-primary color-green"}>  {this.state.Received=="" || this.state.Received==null ? "receiving  pending" : this.state.Received  }</span>) }

                      </Form.Label>
                            </div>
                            <div className="card-body">

                    
                      <div
                        //   className="transactions-list inpute"
                        //  className="table table-borderless align-middle  transactions-list"
                        className="table table-borderless align-middle transactions-list"
                      >
                        { this.state.itemColumns.length > 0 && (
                          <div className="split-assign-coa">
                            <BootstrapTable
                              id="tbltemplate"
                              keyField="templateid"
                              data={this.state.itemdetailsdata}
                              columns={this.state.itemColumns}
                            />
                          </div>
                        )}
                      </div>

                      <div className="d-flex action-btn align-items-center">

                        {false &&
                          <Button
                            type="button"
                            className="btn-ghost mr-auto"
                            onClick={this.handleNewRowitems}
                          >

                            Add Item
                          </Button>}
                      </div>
                      </div>
                      </div>
                      <section className='mt-4'>
                      <div className="card h-100" ref={this.jobRouterRef} >
                      <div className="card-header d-flex align-items-center">
    <span style={{ marginRight: '20px' }}>Job Router</span>
     <div className="btn-group">
                <Dropdown
                  onClick={(e) => { e.stopPropagation(); }}
                  className="more-action"
                >
                  <Dropdown.Toggle
                    className="btn-outline-primary btn btn-primary-white more"
                    id={"dropdown-more"}
                    style={{backgroundColor: "transparent", borderColor: "black",height:"30px",paddingTop:"5px"}}
                  >
                    <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" fill="black"/>
                  <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" fill="black"/>
                  <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" fill="black"/>
                </svg>

                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item eventKey={""} onClick={(e)=>{ this.setState({ showProcessPopup: true }); this.getCustomer();}} >Choose a router</Dropdown.Item>
    
                    {/* <Dropdown.Item eventKey={"selectall"} onClick={() => this.handleOnSelectAll(true,row)}>Select All 
                    
                    
                    </Dropdown.Item> */}
         
                    <Dropdown.Item eventKey={""} onClick={ ()=>{this.setState({ ispopupshow: true, isshowsavetemplate: true });}} >Save as template</Dropdown.Item>
    
    
                  </Dropdown.Menu>
                </Dropdown>
              </div>
    {/* <div className="action">
        <Dropdown className="more-action" style={{ display: 'inline-block' }}>
            <Dropdown.Toggle
                className="btn-outline-primary btn btn-primary more"
                id="dropdown-more"
                style={{ padding: '0.1rem 0.6rem', height: 'auto' }}
            >
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ minHeight: '50px' }}>
                <Dropdown.Item
                    eventKey={"select"}
                    onClick={() => { this.setState({ showProcessPopup: true }); }}
                    disabled={this.state.runningInTracker ? true : false}
                >
                    Select from Template
                </Dropdown.Item>
                <Dropdown.Item eventKey={"save"}>
                    Save as Template
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    </div> */}
                      </div>


                            <div className="card-body">

                            <div className="row">
                       
                       <div className="col-8">
                       <div className="section" style={{ display: "flex" }}>
                         
                       {/* {this.state.runningInTracker!=true && (
                   <div className="notification-banners orange-bg">
                       <div>
                         <span className="bold">
                           Select steps from template  or previous job steps
                         </span>
                       </div>
                      
                       <div> 
       <OverlayTrigger
   placement="top"
   delay={{ show: 250, hide: 400 }}
   overlay={<Tooltip id="addContract">Select Process</Tooltip>}
 >
       <button  onClick={(e)=>{ this.setState({ showProcessPopup: true }); this.getCustomer();}} className='btnheight' disabled={this.state.runningInTracker?true:false}  >
       
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-journal-check" viewBox="0 0 16 16">
<path fill-rule="evenodd" d="M10.854 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 8.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
<path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"/>
<path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"/>
</svg>
         </button>
         </OverlayTrigger>
         </div> 

                     
                     </div>
                       )} */}


                        </div>

                  

                       </div>
                       <div className="col-4">
                       <div style={{float: 'right', 
                        // opacity : (this.state.runningInTracker ? 0.3 :1),pointerEvents: (this.state.runningInTracker ? 'none':'auto')
                        }}>
{/* <Form.Label className="font-semibold" style={{marginRight:'20px'}}>
Tracking
                   </Form.Label>

{ true &&
<BootstrapSwitchButton
checked={!this.state.manualTracking}
offstyle="info"
onstyle="success" 
onlabel='On'
offlabel='Off'
onChange={(checked: boolean) => {
   this.setState({ manualTracking: !checked,isStateChanged:true });
}}
height={25}
width={70}
/>} */}

<div className="btn-group mb-2">
                <Dropdown
                  // onClick={(e) => { e.stopPropagation(); }}
                  onSelect={(event: any) => { this.moreActions(event); }}

                  className="more-action"
                >
                  <Dropdown.Toggle
                    className="btn-outline-primary btn btn-primary-white more"
                    id={"dropdown-more"}
                    style={{backgroundColor: "transparent", borderColor: "black",height:"30px",paddingTop:"5px"}}
                  >
                    <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" fill="black"/>
                  <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" fill="black"/>
                  <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" fill="black"/>
                </svg>

                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item eventKey={"assignment"} >
                        {this.state.isAssignment
                        ? "Remove Assignments" 
                        : "Add Assignments"}
                        </Dropdown.Item>
         
                    <Dropdown.Item eventKey={"qty"}>{this.state.isQty
                        ? "Remove Quantity" 
                        : "Add Quantity"}</Dropdown.Item>
                   {hasAddTrackPermission && 
                    <Dropdown.Item eventKey={"tracking"}> {this.state.manualTracking
                        ? "Enable Tracking" 
                        : "Disable Tracking"}</Dropdown.Item>}

                      <Dropdown.Item eventKey={"reset"} >Reset All</Dropdown.Item>
   
                  </Dropdown.Menu>
                </Dropdown>
              </div>

</div>
                       </div>
                       </div>
                      <div
                       //style={{opacity:( this.state.trackerProcessIds != null ? 0.5 : 1),pointerEvents: (this.state.trackerProcessIds != null  ?'none':'auto')}}

                      >


                     

                        <div className="row g-3">

                  <div className="col-12 col-md-1 pt-2" >
                       
                    
                      </div>  <div className="col-2 col-md-1" >
                      <div className="w-auto d-none" >
                                {this.state.jobprocess !== '' &&

                                  <SingleDropdownListWithoutSearch

                                    tabIndex={this.state.tabEnable}
                                    itemList={this.state.templatelistitem}
                                    handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}

key="id"
                                    defaultItem={this.state.jobprocessid}
                                    defaultText={"Search Template or Create New Template"}
                                    defaultName={this.state.jobprocess}
                                    defaultSelected={this.state.jobprocessid}
                                    controlID="1"
                                    id={"ddltempate"}
                                    // onTAB={this.onTAB.bind(this, "ddltempate-" + rowIndex + "ddl", rowIndex)}
                                    disabled={this.state.processVendorPOCreated}
                                  />
                                }

                            </div>
                            </div>
                            </div>
                          <div
                            className="table table-borderless align-middle transactions-list"
                          // className="transactions-list inpute"
                          //className="table table-borderless align-middle  transactions-list"
                          >
                            {true && templateColumns.length > 0 && this.state.processLoad && (

                              <BootstrapTable
                                key={this.state.manualTracking}
                                id="tbltemplate2"
                                keyField="templateid"
                                data={this.state.jobdetailsdata}
                                columns={templateColumns}
                              />

                            )}
                          </div>
                       

                        <div className="d-flex align-items-center justify-content-end">
                          <div className="d-flex action-btn align-items-center">
                            {/* {!this.state.processVendorPOCreated &&  */}
                            <Button
                              type="button"
                              className="btn-ghost mr-auto"
                              onClick={this.handleNewRow}
                            >
                              <FaCirclePlus className="align-middle lh-1`" /> <span className="align-middle lh-1">Add Row</span>
                            </Button>

                            {/* } */}


                          </div>
                        </div>
                        {/* <div className="d-flex action-btn align-items-center pb-3">
                   {!this.state.processVendorPOCreated && 
                    
                    <Button
                      type="button"
                      className="btn-ghost mr-auto"
                      onClick={this.handleNewRow}
                    >
                      Add Row
                    </Button>
                    
                    }
                  </div> */}
                      </div>
                      </div>
                      </div>
</section>
                      {/* {(this.state.jobid != 0 &&
                        <div className="footer-show height-72">
                          <CommentBox
                            ref={this.ChildComment}
                            hotelid={this.state.hotelValue}
                            entryType={"JobOrder"}
                            uniqueNo={this.state.jobid}
                            precommentlist={this.state.htmlcomment}
                            parentScrollMethod={this.scrollToBottom}
                            updatedCommentItem={this.updatedCommentItem}
                            commentModalClose={this.CommentModalClose}

                          />
                        </div>

                      )} */}

<div >
<div className="row">
                                             <div className="col-12 col-md-6">                 
                                                            <div
                                                              className="filter-sec upload-section"
                                                            >
                                  
                                                              <Form.Group  className="w-100">
                                  
                                                                <div>
                                                                  <Form.Label>
                                                                    {
                                                                      <div className="upload-link mrgn-top">
                                                                        <button
                                                                          type="button"
                                                                          className="btn wht-bg link-btn mr-auto"
                                                                        >
                                                                          Add Attachment
                                                                        </button>
                                                                        <Form.Control
                                                                          id="formControlsFile"
                                                                          type="file"
                                                                          className="form-control-file"
                                                                          multiple
                                                                          disabled={true}
                                                                          onChange={(event: any) =>
                                                                            this.onFileChange(event, "1")
                                                                          }
                                                                          accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                                                        />
                                                                      </div>
                                                                    }
                                                                  </Form.Label>
                                  
                                                                  {this.state.savedfiles.length > 0 && (
                                                                    <Form.Label className="mr-auto">
                                                                      <div className="upload-link mrgn-top">
                                                                        <button
                                                                          type="button"
                                                                          className="btn wht-bg link-btn mr-auto"
                                                                          onClick={this.OpenViewer}
                                                                        // data-bs-toggle="modal" data-bs-target="#exampleModal"
                                                                        >
                                                                          {this.state.isOpenViewer
                                                                            ? "Close Viewer"
                                                                            : "Open Viewer"}
                                                                        </button>
                                                                      </div>
                                                                    </Form.Label>
                                                                  )}
                                                              
                                                               
                                                                <div className="mt-1 py-3 rounded-3 text-center text-secondary"
                                                                  style={{ border: "solid 1px #c0c0c0" }}>
                                                                  <Dropzone
                                                                    // disabled={isBedgeProcessing}
                                                                      disabled={(!hasEditJobPermission && this.state.jobid !== 0) ||
  (!hasAddJobPermission && this.state.jobid === 0)}
                                                                    onDrop={this.onDrop}
                                                                  // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                                                  >
                                                                    {({
                                                                      getRootProps,
                                                                      getInputProps,
                                                                      isDragActive,
                                                                      isDragReject,
                                                                    }) => (
                                                                      <>
                                                                        <aside style={{paddingBottom:'52px'}}>
                                                                          {/* <ul>{files}</ul> */}
                                                                          <ul>{files1}</ul>
                                                                          <ul style={{textAlign:'left'}}> 
                                                                                                                    {this.state.savedfiles.length> 0 && (
                                                                          
                                                                                                                    <Form.Label>
                                                                                                                    {
                                                                                                                      <div className="upload-link mrgn-top">
            {((hasEditJobPermission && this.state.jobid != 0) || (hasAddJobPermission && this.state.jobid === 0)) &&                                                                                                             <button
                                                                                                                          type="button"
                                                                                                                          className="btn"
                                                                                                                          style={{fontSize:'14px'}}
                                                                                                                          onClick={this.handleButtonClick}
                                                                                                                        >
                                                                                                                          <FaCirclePlus style={{color:'#164DA0'}} className="align-middle lh-1`" />{" "}
                                                                                                                          <span style={{color:'#164DA0'}}>Add Attachment</span>
                                                                                                                        </button>}
                                                                                                                        <Form.Control
                                                                                                                          ref={this.fileInputRef}
                                                                                                                          id="formControlsFile"
                                                                                                                          type="file"
                                                                                                                          className="form-control-file"
                                                                                                                          multiple
                                                                                                                          onChange={(event: any) =>
                                                                                                                            this.onFileChange(event, "1")
                                                                                                                          }
                                                                                                                          accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                                                                                                        />
                                                                                                                      </div>
                                                                                                                    }
                                                                                                                    </Form.Label>
                                                                          
                                                                                                                )}</ul>
                                                                        </aside>
                                                                        <section className="container upload-area default">
                                                                         {this.state.savedfiles.length < 1 && (
                                                                            <div
                                                                              {...getRootProps({
                                                                                className:
                                                                                  "dropzone align-items-center",
                                                                                   onClick: (event) => event,
                                                                                // onClick:
                                                                                //   this.state.newSelectfiles.length > 0 ||
                                                                                //     this.state.savedfiles.length > 0
                                                                                //     ? (event) => event.stopPropagation()
                                                                                //     : (event) => event,
                                                                              })}
                                                                            >
                                                                              <input {...getInputProps()} />
                                                                              {/* {this.state.newSelectfiles.length < 1 && */}
                                                                               { this.state.savedfiles.length < 1 && (
                                                                                  <p>
                                                                                    Drag and drop attachment or{" "}
                                                                                    <span>browse files</span> to upload.
                                                                                  </p>
                                                                                )}
                                                                              {(this.state.newSelectfiles.length > 0 ||
                                                                                this.state.savedfiles.length > 0)
                                                                                &&
                                                                                isDragActive && (
                                                                                  <p>
                                                                                    Drag and drop attachment here to upload.
                                                                                  </p>
                                                                                )}
                                                                            </div>
                                                                          )}
                                                                
                                                                        </section>
                                  
                                  
                                                                      </>
                                                                    )}
                                  
                                                                  </Dropzone>
                                  
                                                                </div>
                                                                </div>
                                                              </Form.Group>
                                                            </div>
                                                         
                                             </div>

                                             <div className="col-12 col-md-6">
                      {(this.state.jobid != 0 &&
                        <div className="footer-show height-72">
                          <CommentBox
                            ref={this.ChildComment}
                            hotelid={this.state.hotelValue}
                            entryType={"JobOrder"}
                            uniqueNo={this.state.jobid}
                            precommentlist={this.state.htmlcomment}
                            parentScrollMethod={this.scrollToBottom}
                            updatedCommentItem={this.updatedCommentItem}
                            commentModalClose={this.CommentModalClose}

                          />
                        </div>

                      )}
                      </div>
</div>
                    </div>


                    </div>
                
                  </section>

                  <div className={"footer-section-new viewer-panel"}
            style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
          >
              {((hasEditJobPermission && this.state.jobid > 0) || (hasAddJobPermission && this.state.jobid === 0)) &&
            <div>
              <div className="d-flex gap-3 align-items-center justify-content-end height-72">
              {this.state.isStateChanged && <div className="mr-auto message">
                  <span style={{color: '#065a8c'}}>You have unsaved changes</span>
                </div>}
                <div className="d-flex gap-3 align-items-center">
                
                  
                      <>
                        <Button
                          variant="primary"
                          type="button"
                          className="space btn btn-primary btn-discard"
                          onClick={() =>
                            this.handleDiscard(this.state.orderUniqueNo)
                          }
                        >
                          Discard
                        </Button>
{/* {(this.state.isRecreate)
&& 
<Button
                            id="btnSave"
                            variant="primary"
                            type="button"
                            onClick={() => this.showSaveProcessTemplatePopup(0,1)}
                            disabled={
                              this.state.formData.CustomerID === 0
                                ? true
                                : this.state.isDisabled
                            }
                          // onKeyDown={(e: any) =>
                          //   this.onTAB("btnSave-1", 0, e)
                          // }
                          >
                            Re-Create Job
                          </Button>
} */}

                        {(!this.state.processVendorPOCreated || !this.state.materialVendorPOCreated)
                         
                          && (this.state.reworkCount == 0 || this.state.reworkCount == null)
                          && <Button
                            id="btnSave"
                            variant="primary"
                            type="button"
                            onClick={() => this.showSaveProcessTemplatePopup(0,0)}
                            disabled={
                              this.state.formData.CustomerID === 0
                                ? true
                                : this.state.isDisabled
                            }
                          // onKeyDown={(e: any) =>
                          //   this.onTAB("btnSave-1", 0, e)
                          // }
                          >
                            Save
                          </Button>}
                        {(!this.state.processVendorPOCreated || !this.state.materialVendorPOCreated)
                         
                          && (this.state.reworkCount == 0 || this.state.reworkCount == null)

                          && <Button
                            id="btnSave"
                            variant="primary"
                            type="button"
                            onClick={() => this.showSaveProcessTemplatePopup(1,0)}
                            disabled={
                              this.state.formData.CustomerID === 0
                                ? true
                                : this.state.isDisabled
                            }

                          >
                            Save & Close
                          </Button>}

                      </>
                    
                </div>
              </div>
            </div>
            }
          </div>
                  <br /><br /><br /><br /><br />
               
                </div>
              </div>

  {(showSlideout &&

<TrackerSlideout
closeSlideOut={this.closeSlideOut3}

jobid = {this.state.jobid}
jobno={this.state.formData.jobNo}
customerpo={this.state.CustomerPoNumber}
customername={this.state.selectedCustomer}
orderdate={this.state.orderdate}
partno={this.state.partNo}
partname={this.state.partname}
qty={this.state.qtyOrdered}
>


</TrackerSlideout>

              )}

              {(showVSlideout &&
                <Vendororderslideout
                  closeSlideOut={this.closeSlideOut2}
                  orderid={this.state.orderid}
                  CustomerPoNumber={this.state.vendorPoNo}
                  poNumber={this.state.poNumber}
                  productid={this.state.productid}
                  partname={this.state.partname}
                  partNo={this.state.partNo}
                  qtyOrdered={this.state.qtyOrdered}
                  jobid={this.state.jobid}
                  itemNo={this.state.itemNo}
                  vendororderid={this.state.vendororderid}
                  vendorordertype={this.state.vendorordertype}
                  selectedCustomer={this.state.selectedCustomer}
                  orderdate={this.state.orderdate}
                  dueDate={this.state.dueDate}
                  jobDesc={this.state.jobDesc}
                  id={this.state.id}
                >
                </Vendororderslideout>
              )}

              {this.state.ispopupshow && (
                 <div
               //className="d-flex align-items-center pos-fxd2 index-1000"
               >
                 <div className="react-confirm-alert-overlay confirm-modal undefined">
                  <div className="react-confirm-alert">
                  <div className="react-confirm-alert-body">
                        <div>
                          <div className="d-flex">
                            <h1 style={{ paddingTop: "6px!important" }}> Save As Template</h1>
                            <div className="header-popout ml-auto">
                              <button
                                type="button"
                                className="btn wht-bg cross"
                                onClick={this.handleCloseModel}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                                    fill="#84888C"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                        Would you like to save current process as a template. If yes, please specify template name below.



                        <Form.Group controlId="exampleForm.ControlTextarea1">
                          <Form.Label className="font-semibold">

                          </Form.Label>



                          <Form.Control
                            tabIndex={this.state.tabEnable}
                            id="txtTemplateName"
                            type="text"
                            placeholder="Enter Template Name"
                            value={this.state.templatename}
                            onChange={(e: any) => this.handleChange(e, "templatename")}
                            //autoComplete="off"
                            //disabled={disable}
                            title=""
                          />
                        </Form.Group>
                        <br></br>
                        <div className="react-confirm-alert-button-group">
                          <button
                            type="button"
                            className="btn"
                            onClick={() => this.handleTemplateButton('no')}
                            style={{marginLeft: '10px'}}
                          >
                            {this.state.isshowsavetemplate ? 'Cancel' : 'No' }
                          </button>

                          <div className="upload-link">
                            <button type="button" className="btn"
                              onClick={() => this.handleTemplateButton('yes')}
                              disabled={this.state.templatename.trim() === ''}
                            >
                            {this.state.isshowsavetemplate ? 'Save' : 'Yes' }

                            </button>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}


{this.state.showProcessPopup && (
               <div
               //className="d-flex align-items-center pos-fxd2 index-1000"
               >
                 <div className="react-confirm-alert-overlay confirm-modal undefined">
                    <div className="react-confirm-alert">
                      <div className="react-confirm-alert-body jobprocess-popup-width">
                        <div>
                          <div className="d-flex">
                         
                            <div className="header-popout ml-auto">
                              <button
                                type="button"
                                className="btn wht-bg cross"
                                onClick={(e)=>{this.setState({ showProcessPopup: false });}}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                                    fill="#84888C"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                    


                        <div className="container my-3" >
                <div className="row">
                  <div className="col-6">
                  <div style={{height:'400px', overflowY:'scroll'}}>
                  
                  
                  <div className="process" >
                  <div className="left-panel" >
            
                    
                    <Tab.Container   transition={false} defaultActiveKey="first" >
    
    <section className='p-2'>
<Nav   className="nav nav-underline border-bottom">
<Nav.Item className="nav-item">
  <Nav.Link eventKey="first">Template 
  
  </Nav.Link>
</Nav.Item>
<Nav.Item className="nav-item">
  <Nav.Link eventKey="second">Part 
  
          </Nav.Link>
</Nav.Item>
<Nav.Item className="nav-item">
  <Nav.Link eventKey="third">Job 
  
          </Nav.Link>
</Nav.Item>
<Nav.Item className="nav-item">
  <Nav.Link eventKey="fourth">Customer 
  
          </Nav.Link>
</Nav.Item>
</Nav>
</section>

<Tab.Content>
<Tab.Pane eventKey="first">

{true && 
                   
                   
                   
                   
                   <ToolkitProvider
                   keyField="id"
                   data={this.state.templatelistitem}
                             columns={this.state.columns}
                    //className="table table-striped table-borderless align-middle"
                   search
                 >
                   {(props: {
                           searchProps: JSX.IntrinsicAttributes;
                           baseProps: JSX.IntrinsicAttributes;
                         }) => (
       
       
                       <div >
                         <section className="d-flex flex-wrap">
                         <div className="search-header w-auto px-2 pb-2">
                               <SearchBar
                                 {...props.searchProps}
                                 placeholder={"Search"}
                               />
                             </div>
       
                           <div 
                           //className="input-group w-auto"
                           >
                             
                           </div>
       
                         </section>
                         <section >
                         
                             <BootstrapTable
                           
                               {...props.baseProps}
                              // rowEvents={this.rowEvents}
                               //pagination={paginationFactory(options)}
                               hover
                               condensed
                             //  rowClasses={ rowClasses }
                                //rowEvents={this.rowEvents}
                                selectRow = {{
                                 mode: 'radio',
                                 clickToSelect: true,
                                 classes: "table-active",
                                 // style: { backgroundColor: '#c8e6c9' },
                                 hideSelectColumn: true,  
                                 onSelect: this.handleTemplateOnSelect,
                                 selected: [this.state.selectedTemplateId],
                               }}
                             />
                           
                         </section>
                       </div>
       
                     )
                   }
                 </ToolkitProvider>
                 
                 
                           
                           }

</Tab.Pane>
<Tab.Pane eventKey="second">

{true && 
                   
                    
                   
                   
                   <ToolkitProvider
                   keyField="jobid"
                                             data={
                          //  this.state.partData
                          this.state.partData.filter((ele, ind) => ind === this.state.partData.findIndex(elem => elem.partno === ele.partno && elem.partname === ele.partname && ele.partname !== ""))
                          }
                           columns={this.state.partcolumns}
                //   search
                 >
                   {(props: {
                           searchProps: JSX.IntrinsicAttributes;
                           baseProps: JSX.IntrinsicAttributes;
                         }) => (
       
       
                       <div >
                         <section className="d-flex flex-wrap">
                         <div className="search-header w-auto px-2 pb-2">
                          <Form.Control
              tabIndex={this.state.tabEnable}
              id="search"
              type="text"
              placeholder="Search"
              // value={row.glcode}
                onChange={(e) => this.Getpreviousjob(e,"part")}
              // autoComplete="off"
              // onKeyDown={(e: any) => this.onTAB("glcode", rowIndex, e)}
              // disabled={disable}
              title=""
            />
                             </div>
       
                           <div 
                           //className="input-group w-auto"
                           >
                             
                           </div>
       
                         </section>
                         <section >
                         
                             <BootstrapTable
                           
                               {...props.baseProps}
                              // rowEvents={this.rowEvents}
                               //pagination={paginationFactory(options)}
                               hover
                               condensed
                             //  rowClasses={ rowClasses }
                                //rowEvents={this.rowEvents}
                                selectRow = {{
                                 mode: 'radio',
                                 clickToSelect: true,
                                 classes: "table-active",
                                 // style: { backgroundColor: '#c8e6c9' },
                                 hideSelectColumn: true,  
                                 onSelect: this.handlePartOnSelect,
                                 selected: [this.state.selectedTemplateId],
                               }}
                             />
                           
                         </section>
                       </div>
       
                     )
                   }
                 </ToolkitProvider>
                      
                   
                   
                
     
               
       
                           }

</Tab.Pane>
<Tab.Pane eventKey="third">

{true && 
                   
                   
                   
                   
                
       
                       <div >
                         <section className="d-flex flex-wrap">
                         <div className="search-header w-auto px-2 pb-2">
                               {/* <SearchBar
                                 {...props.searchProps}
                                 placeholder={"Part No / Job No"}
                               /> */}

<Form.Control
              tabIndex={this.state.tabEnable}
              id="searchjob"
              type="text"
              placeholder="Search"
              // value={row.glcode}
                onChange={(e) => this.Getpreviousjob(e,"job")}
              // autoComplete="off"
              // onKeyDown={(e: any) => this.onTAB("glcode", rowIndex, e)}
              // disabled={disable}
              title=""
            />

                             </div>
       
                           <div 
                           //className="input-group w-auto"
                           >
                             
                           </div>
       
                         </section>
                         <section >
                          
                             <BootstrapTable
                           id="tbljob"
                             keyField="jobid"
                           data={
                            
                           this.state.partData
                          
                          
                          }
                           columns={this.state.jobcolumns}
                            
                               hover
                               condensed
                                
                                //rowEvents={this.rowEvents}
                                selectRow = {{
                                 mode: 'radio',
                                 clickToSelect: true,
                                 classes: "table-active",
                                 hideSelectColumn: true,  
                                 onSelect: this.handlejobOnSelect,
                                 selected: [this.state.selectedTemplateId],
                            
                                }}
                             />
                          
                         </section>
                       </div>
       
                   
               
       
                           }

</Tab.Pane>
<Tab.Pane eventKey="fourth">

{true && 
                   
                   <ToolkitProvider
                   keyField="id"
                  //  data={this.state.customerlistitem}
                   data={this.state.customerTemplates}

                             columns={this.state.customercolumns}
                    //className="table table-striped table-borderless align-middle"
                   search
                 >
                   {(props: {
                           searchProps: JSX.IntrinsicAttributes;
                           baseProps: JSX.IntrinsicAttributes;
                         }) => (
       
       
                       <div >
                         <section className="d-flex flex-wrap">
                         <div style={{width:"40%",margin:"5px"}}>
                               {/* <SearchBar
                                 {...props.searchProps}
                                 placeholder={"Search"}
                               /> */}
                               {this.state.customerlistitem.length > 0 && (
                                <SingleSearchDropdownListBootrap
              tabIndex={this.state.tabEnable}
              itemList={this.state.customerlistitem}
              handleSelectedItem={this.handleSelectedItemCustomer.bind(this)}
              defaultItem={"Search"}
              defaultText={"Search Customer"}
              // defaultName={row.processName}

              controlID="1"
              id={"ddlprocess-"  + "ddl"}
            //onTAB={this.onTAB.bind(this, "ddlprocess-" + rowIndex + "ddl", rowIndex)}

            />
          )}
                             </div>
       
                           <div 
                           //className="input-group w-auto"
                           >
                             
                           </div>
       
                         </section>
                         <section >
                         
                             <BootstrapTable
                           
                               {...props.baseProps}
                              // rowEvents={this.rowEvents}
                               //pagination={paginationFactory(options)}
                               hover
                               condensed
                             //  rowClasses={ rowClasses }
                                //rowEvents={this.rowEvents}
                                selectRow = {{
                                 mode: 'radio',
                                 clickToSelect: true,
                                 classes: "table-active",
                                 // style: { backgroundColor: '#c8e6c9' },
                                 hideSelectColumn: true,  
                                 onSelect: this.handleTemplateOnSelect,
                                 selected: [this.state.selectedTemplateId],
                               }}
                             />
                           
                         </section>
                       </div>
       
                     )
                   }
                 </ToolkitProvider>
                 
                 
                           
                           }

</Tab.Pane>
</Tab.Content>

</Tab.Container>
                   
                    
                    </div>
                    </div> 
                    </div>
                  </div>
                  <div className="col-6" >
                  <div style={{height:'400px', overflowY:'scroll'}}>

                 
                  
                  <div   className="" style={{ opacity : (this.state.isPopupSpinner ? 0.3 :1), pointerEvents: (this.state.isPopupSpinner ? 'none':'auto')}}>
                  {(this.state.isPopupSpinner) && (
                  <div style={{position:'fixed',zIndex:'9999',left:'240px',top:'300px'}}>
                   <Spinner animation="border" variant="success" />
                  </div>
            
          )}

                 { true &&
                 <>
                 {/* <div className="d-flex align-items-center p-2">
             <h1>  {this.state.templateType == 'Part' ? this.state.selectedJobNo : this.state.selectedTemplateName}</h1>
              
               </div> */}
                  <div className="d-flex align-items-center">
                 <BootstrapTable
                      keyField="id"
                      data={this.state.processData}
                      columns={this.state.pcolumns}
                    />
                    </div>
                    </>
                    }
                          
                    </div>
                  
                    </div>

                  
                   
                   </div>
          

                 
                </div>
              </div>
                       
<div className="react-confirm-alert-button-group">
            
                  {
                    (
                      <>
                      
                        <Button
                          variant="primary"
                          type="button"
                          className="space btn btn-primary btn-discard"
                          onClick={(e) => {this.applyTemplate();}}
                          
                        >
                          Apply
                        </Button>

                        <Button
                          variant="primary"
                          type="button"
                          className="space btn btn-primary btn-discard"
                          onClick={(e)=>{this.setState({ showProcessPopup: false });}}
                        >
                          Discard
                        </Button>
                      </>
                    )
                  }
                 
                
           
          </div>
                      </div>
                    </div>
            
                  </div>
                </div>
              )}

    

            {/* </Container> */}
            {(this.state.isSpinner || this.state.isSaveSpinner) && (
              <div className="loader-spinner d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="success" />
              </div>
            )}

                {this.state.unsave && (
               <div
               //className="d-flex align-items-center pos-fxd2 index-1000"
               >
                 <div className="react-confirm-alert-overlay confirm-modal undefined">
                  <div className="react-confirm-alert">
                    <div className="react-confirm-alert-body">
                      <h1>Confirmation</h1>
                      Are you sure you want to reset the job router?
                      <div className="react-confirm-alert-button-group">
                        <button
                          type="button"
                          className="btn"
                          onClick={()=>{    this.setState({ unsave: false });
                         }}
                        >
                          No
                        </button>
                        <button
                          type="button"
                          className="btn"
                          onClick={()=>{this.moreActions("confirmReset");}}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}


<Modal show={this.state.showPopup} onHide={()=>{this.setState({showPopup1:false});}}>
          <Modal.Header>
            <Modal.Title>Edit Description</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formDescription">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={this.state.currentNote}
                onChange={(e)=>{this.setState({ currentNote: e.target.value });}}
                placeholder="Edit the description..."
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={()=>{this.setState({showPopup:false});}}>
              Cancel
            </Button>
            <Button variant="primary"   onClick={this.handleNotesSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showPopup1} onHide={()=>{this.setState({showPopup1:false});}}>
          <Modal.Header>
            <Modal.Title>Edit Material Description</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formDescription">
              <Form.Label>Material Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={this.state.currentNote}
                onChange={(e)=>{this.setState({ currentNote: e.target.value });}}
                placeholder="Edit the description..."
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={()=>{this.setState({showPopup1:false});}}>
              Cancel
            </Button>
            <Button variant="primary"   onClick={this.handleNotesSave1}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

          </Container>

      



        </div>

        {(showOrderSlideout &&
                  <Customerorderslideout
                    closeSlideOut={this.closeSlideOutOrder}
                    orderid={this.state.customerorderid}
                  
                  >
                  </Customerorderslideout>
                )}

                {(showPartSlideout &&
                   <ProductSlideout
                                    closeSlideOut={this.closeSlideOutPart}
                                    productid={this.state.productid}
                                  > </ProductSlideout>
                )}

      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});


export default connect(mapStateToProps)(JobCreations);
